import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addCommentToTicket,
  addInternalCommentsToTicket,
  updateTicket,
  handleTicketApproval,
  checkInToTicket,
  checkOutFromTicket,
  updateCheckInCommands,
  updateCheckInInventoryItems,
} from "../../app/Ticket/TicketManagement";
import {
  getInventoryItems,
  getAssetTypes,
  getBrands,
  getModels,
} from "../../app/Inventory/service";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  Paper,
  useMediaQuery,
  useTheme,
  Grid,
  InputLabel,
  TextField,
  Skeleton,
  Stack,
  Chip,
  Avatar,
  InputAdornment,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  FormHelperText,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import TicketModalSkeleton from "./TicketModalSkeleton";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import "../../index.css";
import { SaveButton } from "../../components/commons/Buttons";
import "./ticket.css";
import SelectInput from "../../components/commons/SelectInput";
import MUIDatePicker from "../../components/commons/DatePicker/DatePicker";
import {
  getCompaniesList,
  getCompanyLocations,
} from "../UserMangaement/Service";
import Autocomplete from "../../components/commons/Autocomplete";
import FileUploader from "../../components/FileUploader/FileUploader";
import TicketStatusSelector from "../../components/commons/TicketStatusSelector";
import LabelSelector from "../../components/commons/LabelSelector";
import MultipleUserSelector from "../../components/commons/MultipleUserSelector/MultipleUserSelector";
import TicketPrioritySelector from "../../components/commons/TicketPrioritySelector";
import { stringToColor } from "../../utilities/commonUtils";
import { format } from "date-fns";
import DeclineDialog from "./DeclineModal";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import StatusChangesTimeline from "./StatusChangesTimeline";
import AssetController from "../../components/commons/AssetController/AssetController";
import CheckInIcon from "@mui/icons-material/LocationOn";
import CheckOutIcon from "@mui/icons-material/LocationOff";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  labels,
  assetHealthStatus,
  partsRequiredOptions,
  printerTypes,
  tonerLevel,
} from "../../constants/commonConstants";
import { editAsset } from "../../app/Asset/AssetSlice";
import service from "../../app/Asset/service";
import TextInput from "../../components/commons/TextInput";
import SingleUserSelector from "../../components/commons/SingleUserSelector/SingleUserSelector";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import Collapse from "@mui/material/Collapse";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: "none", // Remove shadow
  border: "1px solid #E2E8F0", // Light border
  borderRadius: "12px !important", // rounded corners
  marginBottom: theme.breakpoints.down("sm") ? "12px" : "16px",
  overflow: "hidden",
  "&:before": {
    display: "none",
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: "#fff", // White header
  color: "#1E293B", // Dark text
  borderBottom: "1px solid #E2E8F0",
  padding: theme.breakpoints.down("sm") ? "8px 16px" : "12px 24px",
  minHeight: "unset",
  "&.Mui-expanded": {
    minHeight: "unset",
    borderBottom: "1px solid #E2E8F0",
  },
  "& .MuiAccordionSummary-content": {
    margin: "12px 0",
    "&.Mui-expanded": {
      margin: "12px 0",
    },
  },
  "& .MuiSvgIcon-root": {
    color: "#64748B",
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: theme.breakpoints.down("sm") ? "16px" : "24px",
}));

const ExistingTicketView = () => {
  const sessionUser = useSelector((state) => state.userData.data);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const existingTicketData = useSelector(
    (state) => state.ticketManagement.existingTicket
  );

  const complainCategories = [
    "IT AMC",
    "Software and website",
    "Printer",
    "CCTV",
  ];
  const [isManualComplainCategory, setIsManualComplainCategory] =
    useState(false);

  useEffect(() => {
    if (
      existingTicketData.complainCategory &&
      !complainCategories.includes(existingTicketData.complainCategory)
    ) {
      setIsManualComplainCategory(true);
    }
  }, [existingTicketData.complainCategory]);

  // Check if ticket is "done" and user is not superAdmin or coreAdmin - disable editing
  const isTicketDoneAndUserNotAdmin =
    existingTicketData.status === "done" &&
    sessionUser.role !== "superAdmin" &&
    sessionUser.role !== "coreAdmin";
  const [toggleCommentsAndActivities, setToggleCommentsAndActivities] =
    useState("comments");
  const [declineModaleOpen, setDeclineModalOpen] = useState(false);
  const [companyLocationsList, setCompanyLocationsList] = useState([]);
  const [checkInExpanded, setCheckInExpanded] = useState(false);
  const [commands, setCommands] = useState([]); // Array of { label: string, details: string }
  const [currentCheckIn, setCurrentCheckIn] = useState(null);
  const [isGettingLocation, setIsGettingLocation] = useState(false);
  const [showCheckInConfirm, setShowCheckInConfirm] = useState(false);
  const [showCheckOutConfirm, setShowCheckOutConfirm] = useState(false);
  const [expandedCommands, setExpandedCommands] = useState({}); // Track which commands are expanded for details input
  const [checkInFiles, setCheckInFiles] = useState([]); // Files for current check-in
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [selectedInventoryItems, setSelectedInventoryItems] = useState([]);
  const [inventoryFilters, setInventoryFilters] = useState({
    itemName: "",
    assetType: "",
    brand: "",
    model: "",
  });
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [inventoryHasMore, setInventoryHasMore] = useState(false);
  const [inventoryCursor, setInventoryCursor] = useState(null);
  const [inventoryAssetTypes, setInventoryAssetTypes] = useState([]);
  const [inventoryBrands, setInventoryBrands] = useState([]);
  const [inventoryModels, setInventoryModels] = useState([]);
  const [quantityDialogOpen, setQuantityDialogOpen] = useState(false);
  const [itemForQuantity, setItemForQuantity] = useState(null);
  const [itemQuantity, setItemQuantity] = useState(1);
  const [selectedAssetData, setSelectedAssetData] = useState(null); // Store fetched asset data
  const [assetEditLoading, setAssetEditLoading] = useState(false);
  const [assetMaintenanceExpanded, setAssetMaintenanceExpanded] =
    useState(true);
  const [assetPrinterExpanded, setAssetPrinterExpanded] = useState(true);
  const [showAssetEditSection, setShowAssetEditSection] = useState(false); // Control visibility of asset edit section

  // Removed dialogContentStyle - moved to sx
  const [companiesList, setCompaniesList] = useState([]);

  const [proposalBreakUps, setProposalBreakUps] = useState([]);

  const [expanded, setExpanded] = useState(false);
  const handleAccordionChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  useEffect(() => {
    getCompaniesList().then((result) => {
      if (result?.data?.length) {
        let tempArr = [];
        result.data.forEach((item) => {
          tempArr.push({ value: item._id, label: item.companyName });
        });
        setCompaniesList(tempArr);
      } else if (result.data) {
        setCompaniesList([
          { value: result.data._id, label: result.data.companyName },
        ]);
        dispatch({
          type: "ticketManagement/updateFieldValues",
          payload: {
            state: "existingTicket",
            field: "company",
            value: {
              value: sessionUser.company._id,
              label: sessionUser.company.companyName,
            },
          },
        });
      }
    });
  }, []);

  useEffect(() => {
    if (sessionUser.userType === "Admin") {
      setToggleCommentsAndActivities("Internal Comments");
    }
    if (sessionUser.userType === "Customer") {
      setToggleCommentsAndActivities("Customer Comments");
    }
  }, [sessionUser.userType]);

  useEffect(() => {
    // If proposal break values are there in the redux state then sync that data with local state
    if (
      existingTicketData?.proposalBreakUps?.length &&
      proposalBreakUps.length === 0
    ) {
      setProposalBreakUps([...existingTicketData?.proposalBreakUps]);
    }
  }, [existingTicketData?.proposalBreakUps?.length]);

  function saveUploadedFilesInRedux(fileData) {
    dispatch({
      type: "ticketManagement/updateFieldValues",
      payload: {
        state: "existingTicket",
        field: "uploads",
        value: [...existingTicketData.uploads, fileData],
      },
    });
  }

  function removeUploadedFileFromRedux(fileName) {
    if (fileName) {
      dispatch({
        type: "ticketManagement/updateFieldValues",
        payload: {
          state: "existingTicket",
          field: "uploads",
          value: existingTicketData.uploads?.filter(
            (item) => item.filename !== fileName
          ),
        },
      });
    }
  }

  const handleProposalBreakUpsGridDataChange = (newValue) => {
    dispatch({
      type: "ticketManagement/updateFieldValues",
      payload: {
        state: "existingTicket",
        field: "proposalBreakUps",
        value: newValue,
      },
    });
    setProposalBreakUps(newValue);
  };

  /**
   * Dispatch create ticket async thunk function to redux
   */
  const handleTicketUpdateSubmission = async () => {
    dispatch(updateTicket(existingTicketData));
  };

  /**
   * Handle API Request state - Error Handling
   */
  useEffect(() => {
    if (
      existingTicketData.isErrorInTicketCreate &&
      existingTicketData?.validationErrors
    ) {
      const errorMessages = Object.values(existingTicketData.validationErrors);

      // Format error messages as a list
      const formattedErrors = (
        <ul>
          {errorMessages.map((errorMessage, index) => (
            <li key={index}>{errorMessage}</li>
          ))}
        </ul>
      );

      toast.error(formattedErrors, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        closeOnClick: false,
        draggable: true,
        style: { width: "600px" },
      });
    }
  }, [existingTicketData?.validationErrors]);

  /**
   * Handle API Request state - Information Message
   */
  useEffect(() => {
    if (existingTicketData?.errorMessage !== "") {
      toast.error(existingTicketData?.errorMessage, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        style: { width: "400px" },
      });
    }
  }, [existingTicketData?.errorMessage]);

  function formatDate(dateTimeString) {
    return format(new Date(dateTimeString), "dd/MM/yyyy hh:mm a"); // Format the date and time
  }

  /**
   * Handle API Request state - Success Message
   */
  useEffect(() => {
    if (existingTicketData?.isSuccessInTicketCreate) {
      toast.success("Ticket has been updated successfully.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        style: { width: "400px" },
      });
      dispatch({
        type: "ticketManagement/updateFieldValues",
        payload: {
          state: "existingTicket",
          field: "isSuccessInTicketCreate",
          value: false,
        },
      });
    }
  }, [existingTicketData?.isSuccessInTicketCreate]);

  const handleAdminApproval = (type, declineReason) => {
    if (type === "approved") {
      dispatch(
        handleTicketApproval({
          data: {
            id: existingTicketData._id,
            status: ["superAdmin", "technicalAdmin", "coreAdmin"].includes(
              sessionUser.role
            )
              ? "superAdminApproved"
              : "customerAdminApproved",
          },
        })
      );
    } else if (type === "declined-without-reason") {
      setDeclineModalOpen(true);
    } else if (type === "decline-with-reason") {
      dispatch(
        handleTicketApproval({
          data: {
            id: existingTicketData._id,
            status: ["superAdmin", "technicalAdmin", "coreAdmin"].includes(
              sessionUser.role
            )
              ? "superAdminDeclined"
              : "customerAdminDeclined",
            declineReason: declineReason,
          },
        })
      );
    }
  };

  useEffect(() => {
    if (existingTicketData?.handleApprovalApiSuccess) {
      toast.success(`Ticket status changed to ${existingTicketData?.status}.`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        style: { width: "400px" },
      });
      dispatch({
        type: "ticketManagement/updateFieldValues",
        payload: {
          state: "existingTicket",
          field: "isSuccessInTicketCreate",
          value: false,
        },
      });
      setDeclineModalOpen(false);
    }
  }, [existingTicketData?.handleApprovalApiSuccess]);

  useEffect(() => {
    if (existingTicketData?.company?.value) {
      getSelectedCompaniesLocations();
    }
  }, [existingTicketData?.company?.value]);

  const getSelectedCompaniesLocations = async () => {
    try {
      const locationsList = await getCompanyLocations(
        existingTicketData.company?.value
      );
      setCompanyLocationsList(
        locationsList?.data?.map((item) => ({
          value: item.id,
          label: item.locationName,
        })) || []
      );
    } catch (error) {
      setCompanyLocationsList([]);
      console.error(`Failed to get locations: ${error.message}`);
    }
  };

  // Get user's current location
  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        // If geolocation not supported, resolve with null values (location is optional)
        resolve({ latitude: undefined, longitude: undefined, address: "" });
        return;
      }

      setIsGettingLocation(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          // Try to get address from coordinates using reverse geocoding
          let address = "";
          try {
            // Using a free reverse geocoding service (you can replace with your preferred service)
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            );
            const data = await response.json();
            address = data.display_name || "";
          } catch (err) {
            console.error("Failed to get address:", err);
          }
          setIsGettingLocation(false);
          resolve({ latitude, longitude, address });
        },
        (error) => {
          setIsGettingLocation(false);
          // If location fails, resolve with null values (location is optional)
          resolve({ latitude: undefined, longitude: undefined, address: "" });
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    });
  };

  // Check if current user has an active check-in
  useEffect(() => {
    if (
      existingTicketData?.checkInCheckOut &&
      existingTicketData.checkInCheckOut.length > 0
    ) {
      const activeCheckIn = [...existingTicketData.checkInCheckOut]
        .filter((record) => {
          const checkedInById = record.checkedInBy?._id || record.checkedInBy;
          const userId = sessionUser._id;
          return (
            checkedInById?.toString() === userId?.toString() &&
            !record.isCheckedOut
          );
        })
        .sort((a, b) => new Date(b.checkInTime) - new Date(a.checkInTime))[0];

      setCurrentCheckIn(activeCheckIn || null);
      // Initialize commands from active check-in if it exists
      if (
        activeCheckIn &&
        activeCheckIn.commands &&
        Array.isArray(activeCheckIn.commands) &&
        activeCheckIn.commands.length > 0
      ) {
        // Handle both old format (string array) and new format (object array)
        const formattedCommands = activeCheckIn.commands
          .filter((cmd) => cmd !== null && cmd !== undefined) // Filter out null/undefined
          .map((cmd) => {
            if (typeof cmd === "string") {
              // Old format - convert to new format
              return { label: cmd, details: "" };
            }
            if (cmd && typeof cmd === "object" && cmd.label) {
              // Already in new format - ensure proper structure
              return {
                label: String(cmd.label),
                details: String(cmd.details || ""),
              };
            }
            // Skip malformed entries
            return null;
          })
          .filter((cmd) => cmd !== null); // Remove any null entries
        setCommands(formattedCommands);
        // Expand all commands that have details
        const expanded = {};
        formattedCommands.forEach((cmd, index) => {
          if (cmd.details && cmd.details.trim() !== "") {
            expanded[index] = true;
          }
        });
        setExpandedCommands(expanded);
      } else if (activeCheckIn) {
        setCommands([]);
        setExpandedCommands({});
      }
      // Initialize selected inventory items from active check-in if it exists
      if (
        activeCheckIn &&
        activeCheckIn.usedInventoryItems &&
        activeCheckIn.usedInventoryItems.length > 0
      ) {
        setSelectedInventoryItems(
          activeCheckIn.usedInventoryItems.map((item) => ({
            inventoryItem: item.inventoryItem,
            quantity: item.quantity,
          }))
        );
      } else if (activeCheckIn) {
        setSelectedInventoryItems([]);
      }
      // Initialize files from active check-in if it exists
      if (
        activeCheckIn &&
        activeCheckIn.files &&
        Array.isArray(activeCheckIn.files)
      ) {
        setCheckInFiles(activeCheckIn.files);
      } else if (activeCheckIn) {
        setCheckInFiles([]);
      }
    } else {
      setCurrentCheckIn(null);
      setCommands([]);
      setExpandedCommands({});
      setSelectedInventoryItems([]);
      setCheckInFiles([]);
    }
  }, [existingTicketData?.checkInCheckOut, sessionUser._id]);

  // Reset asset edit section when assets change or modal closes
  useEffect(() => {
    if (!existingTicketData?.assets || existingTicketData.assets.length === 0) {
      setSelectedAssetData(null);
      setShowAssetEditSection(false);
    }
  }, [existingTicketData?.assets]);

  // Helper function to get toner level severity color
  const getTonerLevelSeverityColor = (tonerLevel) => {
    switch (tonerLevel) {
      case "full":
        return "success";
      case "medium":
        return "info";
      case "low":
        return "warning";
      case "criticallyLow":
      case "nil":
        return "error";
      default:
        return "info";
    }
  };

  // Handle asset field update
  const handleAssetFieldUpdate = (field, value) => {
    if (selectedAssetData) {
      setSelectedAssetData({
        ...selectedAssetData,
        [field]: value,
      });
    }
  };

  // Save asset changes
  const handleSaveAssetChanges = async () => {
    if (!selectedAssetData) return;

    try {
      setAssetEditLoading(true);
      // Reset isSuccess and close modal BEFORE dispatching to prevent any component from reacting
      dispatch({
        type: "assetManagement/updateFieldValues",
        payload: { state: "mainState", field: "isSuccess", value: false },
      });
      dispatch({
        type: "assetManagement/updateFieldValues",
        payload: {
          state: "mainState",
          field: "isCreateOrEditModalOpen",
          value: false,
        },
      });
      dispatch({
        type: "assetManagement/updateFieldValues",
        payload: { state: "mainState", field: "modalMode", value: "update" },
      });

      const result = await dispatch(editAsset(selectedAssetData));
      if (editAsset.fulfilled.match(result)) {
        // Immediately reset isSuccess synchronously to prevent CreateOrUpdateAssetView from showing toast
        // The reducer sets isSuccess=true, so we reset it immediately in the same tick
        dispatch({
          type: "assetManagement/updateFieldValues",
          payload: { state: "mainState", field: "isSuccess", value: false },
        });
        dispatch({
          type: "assetManagement/updateFieldValues",
          payload: {
            state: "mainState",
            field: "isCreateOrEditModalOpen",
            value: false,
          },
        });

        // Use a microtask to show toast after state reset
        Promise.resolve().then(() => {
          toast.success("Asset updated successfully!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        });
        // Refresh asset data using direct API call to avoid opening modal
        service
          .getAsset(selectedAssetData._id)
          .then((response) => {
            if (response.status === 200) {
              setSelectedAssetData(response.data);
            }
          })
          .catch((error) => {
            console.error("Failed to refresh asset data:", error);
          });
      } else {
        throw new Error(result.payload || "Failed to update asset");
      }
    } catch (error) {
      toast.error(error.message || "Failed to update asset", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } finally {
      setAssetEditLoading(false);
    }
  };

  // Handle check-in confirmation
  const handleCheckInClick = () => {
    setShowCheckInConfirm(true);
  };

  // Handle check-in (without commands)
  const handleCheckIn = async () => {
    setShowCheckInConfirm(false);
    try {
      const location = await getCurrentLocation();
      const checkInData = {
        latitude: location.latitude,
        longitude: location.longitude,
        address: location.address || "",
      };

      const result = await dispatch(
        checkInToTicket({
          ticketId: existingTicketData._id,
          checkInData,
        })
      );

      if (checkInToTicket.fulfilled.match(result)) {
        toast.success("Successfully checked in!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        // Ensure modal stays open
        dispatch({
          type: "ticketManagement/updateFieldValues",
          payload: {
            state: "mainState",
            field: "existingTicketModalOpen",
            value: true,
          },
        });
        // Initialize commands and files with empty array for the new check-in
        setCommands([]);
        setExpandedCommands({});
        setCheckInFiles([]);
        // Update ticket data directly with the new check-in from the response
        if (result.payload?.checkInData) {
          const newCheckIn = result.payload.checkInData;
          const updatedCheckInCheckOut = [
            ...(existingTicketData.checkInCheckOut || []),
            newCheckIn,
          ];
          dispatch({
            type: "ticketManagement/updateFieldValues",
            payload: {
              state: "existingTicket",
              field: "checkInCheckOut",
              value: updatedCheckInCheckOut,
            },
          });
          // Set current check-in
          setCurrentCheckIn(newCheckIn);
        }
      } else {
        throw new Error(result.payload || "Failed to check in");
      }
    } catch (error) {
      toast.error(error.message || "Failed to check in", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  // Handle saving commands for active check-in
  const handleSaveCommands = async () => {
    if (!currentCheckIn) {
      return;
    }

    try {
      let inventorySaved = true;
      let hasErrors = false;

      // First save inventory items if any
      if (selectedInventoryItems.length > 0) {
        inventorySaved = await handleSaveInventoryItems();
        if (!inventorySaved) {
          hasErrors = true;
        }
      }

      // Then save commands - filter out empty commands
      const filteredCommands = commands.filter(
        (cmd) => cmd && cmd.label && cmd.label.trim() !== ""
      );
      if (filteredCommands.length > 0) {
        const result = await dispatch(
          updateCheckInCommands({
            ticketId: existingTicketData._id,
            checkInId: currentCheckIn._id,
            commands: filteredCommands,
          })
        );

        if (!updateCheckInCommands.fulfilled.match(result)) {
          hasErrors = true;
          throw new Error(result.payload || "Failed to save commands");
        }
      }

      // Show success message
      if (!hasErrors) {
        const savedItems = [];
        if (selectedInventoryItems.length > 0) savedItems.push("items");
        if (filteredCommands.length > 0) savedItems.push("commands");

        if (savedItems.length > 0) {
          toast.success(`${savedItems.join(" and ")} saved successfully`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }

        // Update local state directly instead of refreshing from server
        // This avoids unnecessary API calls and error toasts
        if (filteredCommands.length > 0 && currentCheckIn) {
          const updatedCheckInCheckOut = (
            existingTicketData.checkInCheckOut || []
          ).map((checkIn) => {
            if (checkIn._id === currentCheckIn._id) {
              return { ...checkIn, commands: filteredCommands };
            }
            return checkIn;
          });
          dispatch({
            type: "ticketManagement/updateFieldValues",
            payload: {
              state: "existingTicket",
              field: "checkInCheckOut",
              value: updatedCheckInCheckOut,
            },
          });
          // Update current check-in state
          setCurrentCheckIn({ ...currentCheckIn, commands: filteredCommands });
        }
      }
    } catch (error) {
      toast.error(error.message || "Failed to save", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  // Handle checkout confirmation
  const handleCheckOutClick = () => {
    setShowCheckOutConfirm(true);
  };

  // Update checkout to save inventory items and commands atomically
  const handleCheckOutWithInventory = async () => {
    setShowCheckOutConfirm(false);
    try {
      // Prepare commands and inventory items to be saved during checkout
      const location = await getCurrentLocation();
      const filteredCommands = commands.filter(
        (cmd) => cmd && cmd.label && cmd.label.trim() !== ""
      );
      const inventoryItemsToSave =
        selectedInventoryItems.length > 0
          ? selectedInventoryItems.map((item) => ({
            inventoryItem: item.inventoryItem._id || item.inventoryItem,
            quantity: item.quantity,
          }))
          : undefined;

      // Prepare files - extract IDs from file objects
      const filesToSend =
        checkInFiles.length > 0
          ? checkInFiles.map((file) => file._id || file.id || file)
          : undefined;

      const checkoutData = {
        latitude: location.latitude,
        longitude: location.longitude,
        address: location.address || "",
        checkInId: currentCheckIn?._id,
        commands: filteredCommands.length > 0 ? filteredCommands : undefined,
        usedInventoryItems: inventoryItemsToSave,
        files: filesToSend,
      };

      const result = await dispatch(
        checkOutFromTicket({
          ticketId: existingTicketData._id,
          checkoutData,
        })
      );

      if (checkOutFromTicket.fulfilled.match(result)) {
        toast.success("Successfully checked out!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        // Ensure modal stays open
        dispatch({
          type: "ticketManagement/updateFieldValues",
          payload: {
            state: "mainState",
            field: "existingTicketModalOpen",
            value: true,
          },
        });
        // Update ticket data directly with the updated check-out from the response
        if (result.payload?.checkoutData) {
          const updatedCheckOut = result.payload.checkoutData;
          const updatedCheckInCheckOut = (
            existingTicketData.checkInCheckOut || []
          ).map((checkIn) => {
            if (checkIn._id === currentCheckIn?._id) {
              return { ...checkIn, ...updatedCheckOut, isCheckedOut: true };
            }
            return checkIn;
          });
          dispatch({
            type: "ticketManagement/updateFieldValues",
            payload: {
              state: "existingTicket",
              field: "checkInCheckOut",
              value: updatedCheckInCheckOut,
            },
          });
        }
        setCurrentCheckIn(null);
        setCommands([]);
        setExpandedCommands({});
        setSelectedInventoryItems([]);
        setCheckInFiles([]);
      } else {
        throw new Error(result.payload || "Failed to checkout");
      }
    } catch (error) {
      toast.error(error.message || "Failed to checkout", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  // Handle checkout - now uses handleCheckOutWithInventory
  const handleCheckOut = handleCheckOutWithInventory;

  // Check if current user is assigned to the ticket
  const isUserAssigned = existingTicketData?.assignedUsers?.some((user) => {
    const userId = user._id || user.value;
    return userId?.toString() === sessionUser._id?.toString();
  });

  // Handle command label selection from LabelSelector
  const handleCommandLabelChange = (selectedLabels) => {
    // selectedLabels is an array of label values (strings)
    const newCommands = selectedLabels.map((label) => {
      // Check if this label already exists in commands
      const existingCommand = commands.find((cmd) => cmd.label === label);
      if (existingCommand) {
        return existingCommand; // Keep existing command with its details
      }
      // New label selected - create new command object
      return { label, details: "" };
    });
    setCommands(newCommands);

    // Update expanded state - expand new commands automatically
    const newExpanded = {};
    newCommands.forEach((cmd, index) => {
      // Expand if it's a new command or if it already has details
      if (!commands.find((c) => c.label === cmd.label) || cmd.details) {
        newExpanded[index] = true;
      }
    });
    setExpandedCommands(newExpanded);
  };

  // Update command details
  const updateCommandDetails = (label, details) => {
    const newCommands = commands.map((cmd) =>
      cmd.label === label ? { ...cmd, details } : cmd
    );
    setCommands(newCommands);
  };

  // Toggle command expansion for details input
  const toggleCommandExpansion = (index) => {
    setExpandedCommands((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Remove command (not needed with LabelSelector, but keep for safety)
  const removeCommand = (label) => {
    const newCommands = commands.filter((cmd) => cmd.label !== label);
    setCommands(newCommands);
    // Remove from expanded state
    const newExpanded = { ...expandedCommands };
    delete newExpanded[label];
    setExpandedCommands(newExpanded);
  };

  // Fetch inventory items with load more
  const fetchInventoryItems = async (reset = false) => {
    if (inventoryLoading) return;

    setInventoryLoading(true);
    try {
      const params = {
        loadMore: "true",
        limit: 50,
        ...inventoryFilters,
      };

      // Remove empty filter values
      Object.keys(params).forEach((key) => {
        if (
          params[key] === "" ||
          params[key] === null ||
          params[key] === undefined
        ) {
          delete params[key];
        }
      });

      if (!reset && inventoryCursor) {
        params.cursor = inventoryCursor;
      } else if (reset) {
        // Reset cursor when resetting
        setInventoryCursor(null);
      }

      console.log("Fetching inventory with params:", params);
      const response = await getInventoryItems(params);
      console.log("Raw API response:", response);
      console.log("Response keys:", Object.keys(response || {}));
      console.log(
        "response.data type:",
        typeof response?.data,
        "isArray:",
        Array.isArray(response?.data)
      );
      console.log("response.data value:", response?.data);

      // Response structure:
      // Backend returns: { message: "Ok", data: [...], hasMore: true, nextCursor: "..." }
      // Response middleware wraps: { success: true, data: { message: "Ok", data: [...], hasMore: true, nextCursor: "..." } }
      // Axios interceptor returns response.data, so: response = { message: "Ok", data: [...], hasMore: true, nextCursor: "..." }
      // Therefore: response.data is the array, response.hasMore and response.nextCursor are the flags

      // Extract the data array - try multiple possible structures
      let data = [];
      if (Array.isArray(response?.data)) {
        data = response.data;
        console.log("Using response.data (array)");
      } else if (response?.data?.data && Array.isArray(response.data.data)) {
        data = response.data.data;
        console.log("Using response.data.data (nested array)");
      } else if (Array.isArray(response)) {
        data = response;
        console.log("Using response (direct array)");
      } else {
        console.log("No array found in response, using empty array");
      }

      console.log("Extracted data length:", data.length);

      // Extract hasMore and nextCursor - try multiple possible locations
      const hasMore = response?.hasMore ?? response?.data?.hasMore ?? false;
      const nextCursor =
        response?.nextCursor ?? response?.data?.nextCursor ?? null;

      console.log("hasMore:", hasMore, "nextCursor:", nextCursor);

      // Ensure data is always an array before setting state
      const safeData = Array.isArray(data) ? data : [];

      if (reset) {
        setInventoryItems(safeData);
      } else {
        setInventoryItems((prev) => {
          const currentItems = Array.isArray(prev) ? prev : [];
          return [...currentItems, ...safeData];
        });
      }

      setInventoryHasMore(hasMore);
      setInventoryCursor(nextCursor);
    } catch (error) {
      console.error("Error fetching inventory items:", error);
      console.error("Error details:", {
        message: error?.message,
        response: error?.response,
        data: error?.response?.data,
      });
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to load inventory items",
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        }
      );
      // Reset state on error
      setInventoryItems([]);
      setInventoryHasMore(false);
      setInventoryCursor(null);
    } finally {
      setInventoryLoading(false);
    }
  };

  // Load asset types, brands, models for filters
  useEffect(() => {
    if (showInventoryModal) {
      const loadFilterData = async () => {
        try {
          const [assetTypesRes] = await Promise.all([getAssetTypes()]);

          setInventoryAssetTypes(
            assetTypesRes.data?.data || assetTypesRes.data || []
          );

          // Reset filters and items when modal opens
          setInventoryFilters({
            itemName: "",
            assetType: "",
            brand: "",
            model: "",
          });
          setInventoryItems([]);
          setInventoryCursor(null);

          // Fetch inventory items
          fetchInventoryItems(true);
        } catch (error) {
          console.error("Failed to load filter data:", error);
        }
      };

      loadFilterData();
    } else {
      // Reset state when modal closes
      setInventoryItems([]);
      setInventoryFilters({
        itemName: "",
        assetType: "",
        brand: "",
        model: "",
      });
      setInventoryCursor(null);
    }
  }, [showInventoryModal]);

  // Update brands when asset type changes
  useEffect(() => {
    if (showInventoryModal && inventoryFilters.assetType) {
      getBrands(inventoryFilters.assetType).then((res) => {
        setInventoryBrands(res.data?.data || res.data || []);
        setInventoryFilters((prev) => ({ ...prev, brand: "", model: "" }));
      });
    } else if (showInventoryModal && !inventoryFilters.assetType) {
      setInventoryBrands([]);
    }
  }, [inventoryFilters.assetType, showInventoryModal]);

  // Update models when brand changes
  useEffect(() => {
    if (showInventoryModal && inventoryFilters.brand) {
      getModels(inventoryFilters.brand).then((res) => {
        setInventoryModels(res.data?.data || res.data || []);
        setInventoryFilters((prev) => ({ ...prev, model: "" }));
      });
    } else if (showInventoryModal && !inventoryFilters.brand) {
      setInventoryModels([]);
    }
  }, [inventoryFilters.brand, showInventoryModal]);

  // Refetch inventory when filters change
  useEffect(() => {
    if (showInventoryModal) {
      fetchInventoryItems(true);
    }
  }, [
    inventoryFilters.itemName,
    inventoryFilters.assetType,
    inventoryFilters.brand,
    inventoryFilters.model,
  ]);

  // Handle item click - open quantity dialog
  const handleItemClick = (item) => {
    setItemForQuantity(item);
    setItemQuantity(1);
    setQuantityDialogOpen(true);
  };

  // Add inventory item to selection after quantity is set
  const confirmAddInventoryItem = () => {
    const qty = parseInt(itemQuantity, 10);
    if (!itemForQuantity || isNaN(qty) || qty < 1) {
      toast.error("Please enter a valid quantity of at least 1", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }

    // Check if item already exists in selection
    const existingIndex = selectedInventoryItems.findIndex(
      (si) => (si.inventoryItem._id || si.inventoryItem) === itemForQuantity._id
    );

    if (existingIndex >= 0) {
      // Update quantity if item already exists
      setSelectedInventoryItems((prev) => {
        const updated = [...prev];
        updated[existingIndex].quantity = qty;
        return updated;
      });
    } else {
      // Add new item
      setSelectedInventoryItems((prev) => [
        ...prev,
        {
          inventoryItem: itemForQuantity,
          quantity: qty,
        },
      ]);
    }

    setQuantityDialogOpen(false);
    setItemForQuantity(null);
    setItemQuantity(1);
  };

  // Remove inventory item from selection
  const removeInventoryItem = (index) => {
    setSelectedInventoryItems((prev) => prev.filter((_, i) => i !== index));
  };

  // Save inventory items (called from Save Items button, Save Commands button, or Checkout)
  const handleSaveInventoryItems = async () => {
    if (!currentCheckIn || selectedInventoryItems.length === 0) {
      if (selectedInventoryItems.length === 0) {
        toast.info("No inventory items selected to save", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
      return true;
    }

    try {
      const inventoryItemsToSave = selectedInventoryItems.map((item) => ({
        inventoryItem: item.inventoryItem._id || item.inventoryItem,
        quantity: item.quantity,
      }));

      const result = await dispatch(
        updateCheckInInventoryItems({
          ticketId: existingTicketData._id,
          checkInId: currentCheckIn._id,
          usedInventoryItems: inventoryItemsToSave,
        })
      );

      if (updateCheckInInventoryItems.fulfilled.match(result)) {
        // Update currentCheckIn with saved items
        const updatedCheckIn = result.payload.checkInData;
        setCurrentCheckIn(updatedCheckIn);

        // Update selectedInventoryItems to match saved items
        const savedItems = updatedCheckIn.usedInventoryItems || [];
        setSelectedInventoryItems(
          savedItems.map((item) => ({
            inventoryItem: item.inventoryItem,
            quantity: item.quantity,
          }))
        );

        toast.success("Inventory items saved successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        // Update ticket state directly with saved inventory items
        if (updatedCheckIn) {
          const updatedCheckInCheckOut = (
            existingTicketData.checkInCheckOut || []
          ).map((checkIn) => {
            if (checkIn._id === currentCheckIn._id) {
              return updatedCheckIn;
            }
            return checkIn;
          });
          dispatch({
            type: "ticketManagement/updateFieldValues",
            payload: {
              state: "existingTicket",
              field: "checkInCheckOut",
              value: updatedCheckInCheckOut,
            },
          });
        }

        return true;
      } else {
        throw new Error(result.payload || "Failed to save inventory items");
      }
    } catch (error) {
      toast.error(error.message || "Failed to save inventory items", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return false;
    }
  };

  return (
    <>
      <Dialog
        open={true}
        fullScreen={false}
        fullWidth
        maxWidth={isMobile ? "md" : "lg"}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: "#F8FAFC",
            backgroundImage: "none",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            maxHeight: isMobile ? "80%" : "calc(100% - 32px)",
            margin: isMobile ? "16px" : "32px",
          },
        }}
      >
        <div className="backdrop" />
        <div className="dialog-wrapper">
          <Paper
            className="dialog-paper"
            elevation={0}
            sx={{
              backgroundColor: "transparent",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <DialogTitle
              sx={{
                backgroundColor: "#fff",
                color: "#1E293B",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: isMobile ? "12px 16px" : "20px 24px",
                minHeight: isMobile ? "56px" : "64px",
                borderBottom: "1px solid #E2E8F0",
                flexShrink: 0,
              }}
            >
              {existingTicketData.isLoading ? (
                <Skeleton variant="text" width={150} /> // Adjust the width as needed
              ) : (
                <>
                  <strong
                    style={{ fontSize: isMobile ? "1.1rem" : "1.25rem" }}
                  >{`Edit Ticket: ${existingTicketData.customTicketId ?? ""
                    }`}</strong>
                </>
              )}
              <IconButton
                edge="end"
                onClick={() => {
                  dispatch({
                    type: "ticketManagement/handleTicketModals",
                    payload: { modalType: "existingTicketModalOpen" },
                  });
                  dispatch({
                    type: "ticketManagement/resetState",
                    payload: { field: "existingTicket" },
                  });
                }}
                aria-label="close"
                sx={{
                  color: "#64748B",
                  transition: "all 0.2s",
                  "&:hover": {
                    color: "#EF4444",
                    backgroundColor: "#FEF2F2",
                    transform: "rotate(90deg)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            {/* <Divider /> */}
            <DialogContent
              className="dialog-content custom-scrollbar"
              sx={{
                padding: isMobile ? "16px 16px 80px 16px" : "32px", // Extra bottom padding on mobile
                backgroundColor: "#F8FAFC",
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
              }}
            >
              <Box sx={{ maxWidth: "100%" }}>
                <Grid container spacing={isMobile ? 1.5 : 2}>
                  {!existingTicketData.isLoading && (
                    <>
                      {/* Helper Text Notifiying Edit Priviliage */}
                      {isTicketDoneAndUserNotAdmin && (
                        <Grid item xs={12}>
                          <FormHelperText
                            sx={{ color: "warning.main", fontWeight: "bold" }}
                          >
                            ** This ticket status is "Done". Only Super Admin
                            and Core Admin can edit tickets with "Done" status.
                            Please contact an admin to make changes.
                          </FormHelperText>
                        </Grid>
                      )}
                      {!isTicketDoneAndUserNotAdmin &&
                        sessionUser.role !== "superAdmin" && (
                          <Grid item xs={12}>
                            <FormHelperText>
                              ** It appears that you have limited access to
                              modify this ticket. Editing and deleting
                              privileges are reserved for Super Admin Users.
                            </FormHelperText>
                          </Grid>
                        )}
                      {/* TICKET HEADING */}
                      <Grid item xs={12}>
                        <InputLabel
                          sx={{
                            marginTop: isMobile ? "4px" : "10px",
                            marginBottom: "4px",
                            fontSize: isMobile ? "0.875rem" : "1rem",
                          }}
                          htmlFor="ticketHead"
                        >
                          Ticket Heading
                        </InputLabel>
                        <div
                          className={
                            !existingTicketData.ticketHead ||
                              existingTicketData.ticketHead === ""
                              ? "ticket-head-div ticket-head-no-input-error"
                              : "ticket-head-div"
                          }
                          name="ticketHead"
                          contentEditable={
                            (sessionUser.role === "superAdmin" ||
                              sessionUser.role === "technicalAdmin") &&
                            !isTicketDoneAndUserNotAdmin
                          }
                          aria-required
                          required={true}
                          onFocus={(e) => {
                            const div = e.target;

                            // Create a range and set it to the end of the content
                            const range = document.createRange();
                            range.selectNodeContents(div);
                            range.collapse(false); // Set the cursor at the end

                            // Select the range to set the cursor position
                            const selection = window.getSelection();
                            selection.removeAllRanges();
                            selection.addRange(range);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              document.execCommand("insertHTML", false, "<br>");
                              e.target.blur(); // Blur the contentEditable div
                            }
                          }}
                          onBlur={(e) => {
                            const div = e.target;
                            const text = div.textContent;

                            // Update your state or dispatch action here when the input is blurred
                            dispatch({
                              type: "ticketManagement/updateFieldValues",
                              payload: {
                                state: "existingTicket",
                                field: "ticketHead",
                                value: text,
                              },
                            });
                          }}
                        >
                          {existingTicketData.ticketHead}
                        </div>
                      </Grid>

                      {/* TICKET DESCRIPTION */}
                      <Grid
                        item
                        xs={12}
                        sx={{ marginBottom: isMobile ? 1.5 : 2 }}
                      >
                        <InputLabel
                          sx={{
                            marginBottom: "4px",
                            fontSize: isMobile ? "0.875rem" : "1rem",
                          }}
                          htmlFor="ticketDescription"
                        >
                          Ticket Description
                        </InputLabel>
                        <div
                          className="ticket-description-div"
                          name="ticketHead"
                          contentEditable={
                            sessionUser.userType === "Admin" &&
                            !isTicketDoneAndUserNotAdmin
                          }
                          aria-required
                          required={true}
                          onFocus={(e) => {
                            const div = e.target;

                            // Create a range and set it to the end of the content
                            const range = document.createRange();
                            range.selectNodeContents(div);
                            range.collapse(false); // Set the cursor at the end

                            // Select the range to set the cursor position
                            const selection = window.getSelection();
                            selection.removeAllRanges();
                            selection.addRange(range);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              document.execCommand("insertHTML", false, "<br>");
                              e.target.blur(); // Blur the contentEditable div
                            }
                          }}
                          onBlur={(e) => {
                            const div = e.target;
                            const text = div.textContent;

                            // Update your state or dispatch action here when the input is blurred
                            dispatch({
                              type: "ticketManagement/updateFieldValues",
                              payload: {
                                state: "existingTicket",
                                field: "ticketDescription",
                                value: text,
                              },
                            });
                          }}
                        >
                          {existingTicketData.ticketDescription}
                        </div>
                      </Grid>

                      {/* COMPANY */}
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          label="Company"
                          name="company"
                          value={existingTicketData.company}
                          onChange={(e) => {
                            if (
                              sessionUser.role === "superAdmin" ||
                              sessionUser.role === "technicalAdmin" ||
                              sessionUser.role === "coreAdmin"
                            ) {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "company",
                                  value: e.target.value,
                                },
                              });
                            }
                          }}
                          options={
                            sessionUser.role === "superAdmin" ||
                              sessionUser.role === "technicalAdmin" ||
                              sessionUser.role === "coreAdmin"
                              ? companiesList
                              : [existingTicketData.company]
                          }
                          required={true}
                          error={!existingTicketData.company}
                          disabled={
                            !(
                              sessionUser.role === "superAdmin" ||
                              sessionUser.role === "technicalAdmin" ||
                              sessionUser.role === "coreAdmin"
                            )
                          }
                        />
                      </Grid>

                      {/* COMPANY LOCATION */}
                      {(sessionUser.role === "coreAdmin" ||
                        sessionUser.role === "superAdmin" ||
                        sessionUser.role === "technicalAdmin" ||
                        (existingTicketData.companyLocation &&
                          existingTicketData.companyLocation !== "")) && (
                          <Grid item xs={12} sm={6}>
                            <Autocomplete
                              label="Company Location"
                              name="companyLocation"
                              value={existingTicketData.companyLocation}
                              disabled={isTicketDoneAndUserNotAdmin}
                              onChange={(e) => {
                                if (!isTicketDoneAndUserNotAdmin) {
                                  dispatch({
                                    type: "ticketManagement/updateFieldValues",
                                    payload: {
                                      state: "existingTicket",
                                      field: "companyLocation",
                                      value: e.target.value,
                                    },
                                  });
                                }
                              }}
                              options={companyLocationsList}
                              required={false}
                            // error={(!data.company && !data.userType === 'Admin')}
                            />
                          </Grid>
                        )}

                      <Grid item xs={12} sm={6}>
                        <LabelSelector
                          value={existingTicketData.labels}
                          onChange={(newValue) => {
                            dispatch({
                              type: "ticketManagement/updateFieldValues",
                              payload: {
                                state: "existingTicket",
                                field: "labels",
                                value: newValue,
                              },
                            });
                          }}
                          disableFlag={
                            (sessionUser.role !== "superAdmin" &&
                              sessionUser.role !== "technicalAdmin" &&
                              sessionUser.role !== "technician" &&
                              sessionUser.role !== "coreAdmin" &&
                              sessionUser.role !== "supportAgent") ||
                            isTicketDoneAndUserNotAdmin
                          }
                        />
                      </Grid>

                      {/* TICKET STATUS */}
                      <Grid item xs={12} sm={6}>
                        <TicketStatusSelector
                          name={"status"}
                          label="Status"
                          value={existingTicketData.status}
                          onChange={(e) => {
                            if (
                              !isTicketDoneAndUserNotAdmin &&
                              sessionUser.userType === "Admin"
                            ) {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "status",
                                  value: e.target.value,
                                },
                              });
                            } else {
                              return;
                            }
                          }}
                          disableFlag={
                            (sessionUser.role !== "superAdmin" &&
                              sessionUser.role !== "technicalAdmin" &&
                              sessionUser.role !== "technician" &&
                              sessionUser.role !== "coreAdmin" &&
                              sessionUser.role !== "supportAgent") ||
                            existingTicketData.approvalRequireFlag ||
                            isTicketDoneAndUserNotAdmin
                          }
                        />
                        {existingTicketData.approvalRequireFlag && (
                          <FormHelperText>
                            ** This ticket requires Admin review and approval.
                          </FormHelperText>
                        )}
                      </Grid>

                      {/* APPROVAL REASON TEXT INPUT */}
                      {((existingTicketData.status ===
                        "reqCustomerAdminApproval" &&
                        [
                          "coreAdmin",
                          "superAdmin",
                          "customerAdmin",
                          "technicalAdmin",
                          "technician",
                          "supportAgent",
                        ].includes(sessionUser.role)) ||
                        (existingTicketData.status ===
                          "reqSuperAdminApproval" &&
                          [
                            "coreAdmin",
                            "superAdmin",
                            "technicalAdmin",
                            "technician",
                            "supportAgent",
                          ].includes(sessionUser.role))) && (
                          <Grid item xs={12}>
                            <TextField
                              id="admins-approval-reason"
                              label="Approval Reason"
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={4}
                              required
                              value={existingTicketData.approvalReason}
                              disabled={isTicketDoneAndUserNotAdmin}
                              onChange={(e) => {
                                if (
                                  !isTicketDoneAndUserNotAdmin &&
                                  sessionUser.userType === "Admin"
                                ) {
                                  dispatch({
                                    type: "ticketManagement/updateFieldValues",
                                    payload: {
                                      state: "existingTicket",
                                      field: "approvalReason",
                                      value: e.target.value,
                                    },
                                  });
                                } else {
                                  return;
                                }
                              }}
                              error={
                                (existingTicketData.status ===
                                  "reqCustomerAdminApproval" ||
                                  existingTicketData.status ===
                                  "reqSuperAdminApproval") &&
                                !existingTicketData.approvalReason
                              }
                            />
                          </Grid>
                        )}

                      {/* DUE DATE */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <MUIDatePicker
                          label="Due Date"
                          value={
                            isNaN(Date.parse(existingTicketData.dueDate))
                              ? null
                              : new Date(existingTicketData.dueDate)
                          }
                          onChange={(e) => {
                            dispatch({
                              type: "ticketManagement/updateFieldValues",
                              payload: {
                                state: "existingTicket",
                                field: "dueDate",
                                value: e,
                              },
                            });
                          }}
                          onClear={() => {
                            dispatch({
                              type: "ticketManagement/updateFieldValues",
                              payload: {
                                state: "existingTicket",
                                field: "dueDate",
                                value: null,
                              },
                            });
                          }}
                          disableFlag={
                            (sessionUser.role !== "coreAdmin" &&
                              sessionUser.role !== "superAdmin" &&
                              sessionUser.role !== "technicalAdmin" &&
                              sessionUser.role !== "technician") ||
                            isTicketDoneAndUserNotAdmin
                          }
                          minDate={Date.now()}
                          timeZone={
                            Intl.DateTimeFormat().resolvedOptions().timeZone
                          }
                        />
                      </Grid>

                      {/* TICKET PRIORITY */}
                      <Grid item xs={12} sm={6}>
                        <TicketPrioritySelector
                          name={"priority"}
                          required={true}
                          label="Priority"
                          value={existingTicketData.priority}
                          disableFlag={
                            (sessionUser.role !== "coreAdmin" &&
                              sessionUser.role !== "superAdmin" &&
                              sessionUser.role !== "technicalAdmin" &&
                              sessionUser.role !== "technician") ||
                            isTicketDoneAndUserNotAdmin
                          }
                          onChange={(e) => {
                            if (!isTicketDoneAndUserNotAdmin) {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "priority",
                                  value: e.target.value,
                                },
                              });
                            }
                          }}
                        />
                      </Grid>

                      {/* PAYMENT STATUS */}
                      {(sessionUser.role === "coreAdmin" ||
                        sessionUser.role === "superAdmin" ||
                        sessionUser.role === "technicalAdmin" ||
                        sessionUser.role === "technician" ||
                        sessionUser.role === "supportAgent") && (
                          <>
                            <Grid item xs={12} sm={6}>
                              <SelectInput
                                label={"Payment Status"}
                                value={existingTicketData.paymentStatus}
                                required={true}
                                disabled={isTicketDoneAndUserNotAdmin}
                                onChange={(e) => {
                                  if (!isTicketDoneAndUserNotAdmin) {
                                    dispatch({
                                      type: "ticketManagement/updateFieldValues",
                                      payload: {
                                        state: "existingTicket",
                                        field: "paymentStatus",
                                        value: e.target.value,
                                      },
                                    });
                                  }
                                }}
                                options={[
                                  { key: "required", name: "Payment Required" },
                                  {
                                    key: "notRequired",
                                    name: "Payment Not Required",
                                  },
                                  { key: "paid", name: "Paid" },
                                  {
                                    key: "paymentPending",
                                    name: "Payment Pending",
                                  },
                                ]}
                              />
                            </Grid>
                          </>
                        )}

                      <Grid item xs={12} sm={6}>
                        <AssetController
                          disabled={isTicketDoneAndUserNotAdmin}
                          onChange={(newValue) => {
                            if (!isTicketDoneAndUserNotAdmin) {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "assets",
                                  value: newValue,
                                },
                              });
                            }
                          }}
                          selectedAssets={existingTicketData.assets}
                          company={existingTicketData?.company?.value}
                          location={
                            existingTicketData?.companyLocation?.value || ""
                          }
                        />
                      </Grid>
                      {existingTicketData.assets.length > 0 && (
                        <Grid item xs={12}>
                          <Grid
                            container
                            spacing={1}
                            sx={{
                              marginTop: isMobile ? "8px" : "10px",
                              padding: isMobile ? "0.75rem" : "1rem",
                              alignItems: "center",
                            }}
                          >
                            {existingTicketData.assets?.map((asset) => (
                              <Grid item key={asset.value}>
                                <Chip
                                  label={`${asset.label}${asset.model ? ` - ${asset.model}` : ""
                                    } - ${asset.contractType}`}
                                  sx={{
                                    borderRadius: "8px",
                                    marginRight: "4px",
                                    marginBottom: isMobile ? "4px" : "0",
                                    fontWeight: 500,
                                    fontSize: isMobile ? "0.875rem" : "1.1rem",
                                    textTransform: "uppercase",
                                  }}
                                  size={isMobile ? "small" : "medium"}
                                />
                              </Grid>
                            ))}
                            <Grid item>
                              <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => {
                                  if (
                                    !showAssetEditSection &&
                                    existingTicketData.assets.length > 0
                                  ) {
                                    // Fetch asset data when opening (using direct API call to avoid opening asset modal)
                                    const firstAssetId =
                                      existingTicketData.assets[0]?.value ||
                                      existingTicketData.assets[0]?._id;
                                    if (
                                      firstAssetId &&
                                      (!selectedAssetData ||
                                        selectedAssetData._id !== firstAssetId)
                                    ) {
                                      setAssetEditLoading(true);
                                      service
                                        .getAsset(firstAssetId)
                                        .then((response) => {
                                          if (response.status === 200) {
                                            setSelectedAssetData(response.data);
                                            setShowAssetEditSection(true);
                                          } else {
                                            toast.error(
                                              "Failed to load asset details",
                                              {
                                                position:
                                                  toast.POSITION.TOP_CENTER,
                                                autoClose: 3000,
                                              }
                                            );
                                          }
                                        })
                                        .catch((error) => {
                                          toast.error(
                                            "Failed to load asset details",
                                            {
                                              position:
                                                toast.POSITION.TOP_CENTER,
                                              autoClose: 3000,
                                            }
                                          );
                                        })
                                        .finally(() => {
                                          setAssetEditLoading(false);
                                        });
                                    } else {
                                      setShowAssetEditSection(true);
                                    }
                                  } else {
                                    setShowAssetEditSection(
                                      !showAssetEditSection
                                    );
                                  }
                                }}
                                disabled={
                                  isTicketDoneAndUserNotAdmin ||
                                  assetEditLoading
                                }
                                sx={{ ml: 1 }}
                              >
                                {assetEditLoading
                                  ? "Loading..."
                                  : showAssetEditSection
                                    ? "Hide Asset Edit"
                                    : "Edit Asset"}
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {/* ASSET EDIT SECTION */}
                      {existingTicketData.assets.length > 0 &&
                        showAssetEditSection &&
                        selectedAssetData && (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Card
                              sx={{
                                backgroundColor: "#f5f5f5",
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              <CardContent>
                                {/* Basic Asset Details Display (Read-only) */}
                                <Box
                                  sx={{
                                    mb: 2,
                                    p: 2,
                                    backgroundColor: "#fff",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{ mb: 1, fontWeight: "bold" }}
                                  >
                                    Asset Details
                                  </Typography>
                                  <Grid container spacing={2}>
                                    <Grid item xs={isMobile ? 12 : 4}>
                                      <Typography variant="body2">
                                        <strong>Machine Code:</strong>{" "}
                                        {selectedAssetData.machineCode || "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={isMobile ? 12 : 4}>
                                      <Typography variant="body2">
                                        <strong>Asset Name:</strong>{" "}
                                        {selectedAssetData.assetName || "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={isMobile ? 12 : 4}>
                                      <Typography variant="body2">
                                        <strong>Asset Type:</strong>{" "}
                                        {selectedAssetData.assetType || "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={isMobile ? 12 : 4}>
                                      <Typography variant="body2">
                                        <strong>Model:</strong>{" "}
                                        {selectedAssetData.model || "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={isMobile ? 12 : 4}>
                                      <Typography variant="body2">
                                        <strong>Serial Number:</strong>{" "}
                                        {selectedAssetData.serialNumber ||
                                          "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={isMobile ? 12 : 4}>
                                      <Typography variant="body2">
                                        <strong>Contract Type:</strong>{" "}
                                        {selectedAssetData.contractType ||
                                          "N/A"}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Box>

                                {/* Maintenance Details Section */}
                                <Box sx={{ mb: 2 }}>
                                  <Chip
                                    icon={<EngineeringIcon />}
                                    label={
                                      <Typography variant="h6">
                                        Maintenance Details
                                      </Typography>
                                    }
                                    clickable
                                    onClick={() =>
                                      setAssetMaintenanceExpanded(
                                        !assetMaintenanceExpanded
                                      )
                                    }
                                    deleteIcon={
                                      assetMaintenanceExpanded ? (
                                        <ExpandLessIcon />
                                      ) : (
                                        <ExpandMoreIcon />
                                      )
                                    }
                                    onDelete={() => { }}
                                    sx={{
                                      borderRadius: "8px",
                                      cursor: "pointer",
                                      mb: 1,
                                      "&:hover": {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                      },
                                    }}
                                  />
                                  <Divider sx={{ height: "2px", mb: 1 }} />
                                  <Collapse in={assetMaintenanceExpanded}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={isMobile ? 12 : 4}>
                                        <SelectInput
                                          required={true}
                                          name={"healthStatus"}
                                          label="Health Status"
                                          value={selectedAssetData.healthStatus}
                                          options={assetHealthStatus}
                                          error={
                                            !selectedAssetData.healthStatus ||
                                            [
                                              "repairNeeded",
                                              "maintenancePending",
                                            ].includes(
                                              selectedAssetData.healthStatus
                                            )
                                          }
                                          onChange={(e) =>
                                            handleAssetFieldUpdate(
                                              "healthStatus",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={isMobile ? 6 : 4}>
                                        <MUIDatePicker
                                          label="Last Service Date"
                                          value={
                                            isNaN(
                                              Date.parse(
                                                selectedAssetData.lastService
                                              )
                                            )
                                              ? null
                                              : new Date(
                                                selectedAssetData.lastService
                                              )
                                          }
                                          onChange={(e) => {
                                            handleAssetFieldUpdate(
                                              "lastService",
                                              e
                                            );
                                            if (
                                              selectedAssetData.serviceDurationInDays &&
                                              !isNaN(Date.parse(e))
                                            ) {
                                              const lastServiceDate = new Date(
                                                e
                                              );
                                              const nextServiceDate = new Date(
                                                lastServiceDate.setDate(
                                                  lastServiceDate.getDate() +
                                                  Number(
                                                    selectedAssetData.serviceDurationInDays
                                                  )
                                                )
                                              );
                                              handleAssetFieldUpdate(
                                                "nextService",
                                                nextServiceDate
                                              );
                                            }
                                          }}
                                          onClear={() =>
                                            handleAssetFieldUpdate(
                                              "lastService",
                                              null
                                            )
                                          }
                                          maxDate={Date.now()}
                                          timeZone={
                                            Intl.DateTimeFormat().resolvedOptions()
                                              .timeZone
                                          }
                                          disableFlag={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={isMobile ? 6 : 4}>
                                        <TextInput
                                          label={`Service in every ${selectedAssetData.serviceDurationInDays ||
                                            ""
                                            } days`}
                                          name={"serviceDurationInDays"}
                                          required={true}
                                          type={"number"}
                                          value={
                                            selectedAssetData.serviceDurationInDays ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            handleAssetFieldUpdate(
                                              "serviceDurationInDays",
                                              e.target.value
                                            );
                                            if (
                                              e.target.value &&
                                              !isNaN(
                                                Date.parse(
                                                  selectedAssetData.lastService
                                                )
                                              )
                                            ) {
                                              const lastServiceDate =
                                                selectedAssetData.lastService
                                                  ? new Date(
                                                    selectedAssetData.lastService
                                                  )
                                                  : new Date();
                                              const nextServiceDate = new Date(
                                                lastServiceDate.setDate(
                                                  lastServiceDate.getDate() +
                                                  Number(e.target.value)
                                                )
                                              );
                                              handleAssetFieldUpdate(
                                                "nextService",
                                                nextServiceDate
                                              );
                                            }
                                          }}
                                          disabled={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={isMobile ? 6 : 4}>
                                        <MUIDatePicker
                                          label="Next Service Date"
                                          value={
                                            isNaN(
                                              Date.parse(
                                                selectedAssetData.nextService
                                              )
                                            )
                                              ? null
                                              : new Date(
                                                selectedAssetData.nextService
                                              )
                                          }
                                          onChange={(e) =>
                                            handleAssetFieldUpdate(
                                              "nextService",
                                              e
                                            )
                                          }
                                          onClear={() =>
                                            handleAssetFieldUpdate(
                                              "nextService",
                                              null
                                            )
                                          }
                                          minDate={new Date()}
                                          timeZone={
                                            Intl.DateTimeFormat().resolvedOptions()
                                              .timeZone
                                          }
                                          disableFlag={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={isMobile ? 12 : 6}>
                                        <SingleUserSelector
                                          label="Last Service By"
                                          value={
                                            selectedAssetData.lastServiceBy
                                          }
                                          onChange={(newValue) =>
                                            handleAssetFieldUpdate(
                                              "lastServiceBy",
                                              newValue
                                            )
                                          }
                                          disabled={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={2}>
                                        <SelectInput
                                          required={true}
                                          name={"partsRequired"}
                                          label="Parts Required"
                                          value={
                                            selectedAssetData.partsRequired
                                          }
                                          options={partsRequiredOptions}
                                          onChange={(e) => {
                                            handleAssetFieldUpdate(
                                              "partsRequired",
                                              e.target.value
                                            );
                                            if (e.target.value === "no") {
                                              handleAssetFieldUpdate(
                                                "partsNotes",
                                                ""
                                              );
                                            }
                                          }}
                                          disabled={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                        />
                                      </Grid>
                                      {(selectedAssetData.partsRequired ===
                                        "yes" ||
                                        selectedAssetData.partsRequired ===
                                        "partsReceived") && (
                                          <Grid item xs={12}>
                                            <TextInput
                                              required={
                                                selectedAssetData.partsRequired ===
                                                "yes"
                                              }
                                              name={"partsNotes"}
                                              multiline
                                              minRows={2}
                                              label="Parts Required Notes"
                                              value={
                                                selectedAssetData.partsNotes || ""
                                              }
                                              onChange={(e) =>
                                                handleAssetFieldUpdate(
                                                  "partsNotes",
                                                  e.target.value
                                                )
                                              }
                                              disabled={
                                                isTicketDoneAndUserNotAdmin ||
                                                assetEditLoading
                                              }
                                            />
                                          </Grid>
                                        )}
                                    </Grid>
                                  </Collapse>
                                </Box>

                                {/* Printer Details Section (only if asset type is printer) */}
                                {selectedAssetData.assetType === "printer" && (
                                  <Box sx={{ mb: 2 }}>
                                    <Chip
                                      icon={<PrintRoundedIcon />}
                                      label={
                                        <Typography variant="h6">
                                          Printer Details
                                        </Typography>
                                      }
                                      clickable
                                      onClick={() =>
                                        setAssetPrinterExpanded(
                                          !assetPrinterExpanded
                                        )
                                      }
                                      deleteIcon={
                                        assetPrinterExpanded ? (
                                          <ExpandLessIcon />
                                        ) : (
                                          <ExpandMoreIcon />
                                        )
                                      }
                                      onDelete={() => { }}
                                      sx={{
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        mb: 1,
                                        "&:hover": {
                                          backgroundColor: "rgba(0, 0, 0, 0.1)",
                                        },
                                      }}
                                    />
                                    <Divider sx={{ height: "2px", mb: 1 }} />
                                    <Collapse in={assetPrinterExpanded}>
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          xs={
                                            isMobile
                                              ? 6
                                              : selectedAssetData.printerType ===
                                                "black&White"
                                                ? 4
                                                : 2
                                          }
                                        >
                                          <SelectInput
                                            required={true}
                                            name={"printerType"}
                                            label="Printer Type"
                                            value={
                                              selectedAssetData.printerType
                                            }
                                            options={printerTypes}
                                            onChange={(e) =>
                                              handleAssetFieldUpdate(
                                                "printerType",
                                                e.target.value
                                              )
                                            }
                                            disabled={
                                              isTicketDoneAndUserNotAdmin ||
                                              assetEditLoading
                                            }
                                          />
                                        </Grid>
                                        {selectedAssetData.printerType ===
                                          "black&White" ? (
                                          <>
                                            <Grid item xs={isMobile ? 12 : 4}>
                                              <TextInput
                                                label="Counter Limit (Black)"
                                                name={"counterLimitBlack"}
                                                value={
                                                  selectedAssetData.counterLimitBlack ||
                                                  ""
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "counterLimitBlack",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={isMobile ? 12 : 4}>
                                              <TextInput
                                                label="Current Counter (Black)"
                                                name={"currentCounterBlack"}
                                                value={
                                                  selectedAssetData.currentCounterBlack ||
                                                  ""
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "currentCounterBlack",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SelectInput
                                                required={true}
                                                name={"tonerLevelBlack"}
                                                label="Black Toner Level"
                                                value={
                                                  selectedAssetData.tonerLevelBlack
                                                }
                                                color={getTonerLevelSeverityColor(
                                                  selectedAssetData.tonerLevelBlack
                                                )}
                                                error={[
                                                  "criticallyLow",
                                                  "low",
                                                  "nil",
                                                ].includes(
                                                  selectedAssetData.tonerLevelBlack
                                                )}
                                                options={tonerLevel}
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "tonerLevelBlack",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                          </>
                                        ) : (
                                          <>
                                            <Grid item xs={isMobile ? 12 : 2.5}>
                                              <TextInput
                                                label="Counter Limit (Black)"
                                                name={"counterLimitBlack"}
                                                value={
                                                  selectedAssetData.counterLimitBlack ||
                                                  ""
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "counterLimitBlack",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={isMobile ? 12 : 2.5}>
                                              <TextInput
                                                label="Current Counter (Black)"
                                                name={"currentCounterBlack"}
                                                value={
                                                  selectedAssetData.currentCounterBlack ||
                                                  ""
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "currentCounterBlack",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={isMobile ? 12 : 2.5}>
                                              <TextInput
                                                label="Counter Limit (Color)"
                                                name={"counterLimitColor"}
                                                value={
                                                  selectedAssetData.counterLimitColor ||
                                                  ""
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "counterLimitColor",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={isMobile ? 12 : 2.5}>
                                              <TextInput
                                                label="Current Counter (Color)"
                                                name={"currentCounterColor"}
                                                value={
                                                  selectedAssetData.currentCounterColor ||
                                                  ""
                                                }
                                                type="number"
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "currentCounterColor",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SelectInput
                                                required={true}
                                                name={"wasteToner"}
                                                label="Waste Toner"
                                                value={
                                                  selectedAssetData.wasteToner
                                                }
                                                error={[
                                                  "full",
                                                  "medium",
                                                ].includes(
                                                  selectedAssetData.wasteToner
                                                )}
                                                options={tonerLevel}
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "wasteToner",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SelectInput
                                                required={true}
                                                name={"tonerLevelYellow"}
                                                label="Yellow Toner Level"
                                                value={
                                                  selectedAssetData.tonerLevelYellow
                                                }
                                                color={getTonerLevelSeverityColor(
                                                  selectedAssetData.tonerLevelYellow
                                                )}
                                                options={tonerLevel}
                                                error={[
                                                  "criticallyLow",
                                                  "low",
                                                  "nil",
                                                ].includes(
                                                  selectedAssetData.tonerLevelYellow
                                                )}
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "tonerLevelYellow",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SelectInput
                                                required={true}
                                                name={"tonerLevelBlack"}
                                                label="Black Toner Level"
                                                value={
                                                  selectedAssetData.tonerLevelBlack
                                                }
                                                color={getTonerLevelSeverityColor(
                                                  selectedAssetData.tonerLevelBlack
                                                )}
                                                error={[
                                                  "criticallyLow",
                                                  "low",
                                                  "nil",
                                                ].includes(
                                                  selectedAssetData.tonerLevelBlack
                                                )}
                                                options={tonerLevel}
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "tonerLevelBlack",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SelectInput
                                                required={true}
                                                name={"tonerLevelCyan"}
                                                label="Cyan Toner Level"
                                                value={
                                                  selectedAssetData.tonerLevelCyan
                                                }
                                                color={getTonerLevelSeverityColor(
                                                  selectedAssetData.tonerLevelCyan
                                                )}
                                                error={[
                                                  "criticallyLow",
                                                  "low",
                                                  "nil",
                                                ].includes(
                                                  selectedAssetData.tonerLevelCyan
                                                )}
                                                options={tonerLevel}
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "tonerLevelCyan",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SelectInput
                                                required={true}
                                                name={"tonerLevelMagenta"}
                                                label="Magenta Toner Level"
                                                value={
                                                  selectedAssetData.tonerLevelMagenta
                                                }
                                                color={getTonerLevelSeverityColor(
                                                  selectedAssetData.tonerLevelMagenta
                                                )}
                                                error={[
                                                  "criticallyLow",
                                                  "low",
                                                  "nil",
                                                ].includes(
                                                  selectedAssetData.tonerLevelMagenta
                                                )}
                                                options={tonerLevel}
                                                onChange={(e) =>
                                                  handleAssetFieldUpdate(
                                                    "tonerLevelMagenta",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  isTicketDoneAndUserNotAdmin ||
                                                  assetEditLoading
                                                }
                                              />
                                            </Grid>
                                          </>
                                        )}
                                      </Grid>
                                    </Collapse>
                                  </Box>
                                )}

                                {/* Consumer Stocks Section (only if asset type is printer) */}
                                {selectedAssetData.assetType === "printer" && (
                                  <Box sx={{ mb: 2 }}>
                                    <Typography
                                      variant="h6"
                                      sx={{ mb: 1, fontWeight: "bold" }}
                                    >
                                      Consumer Stocks (Toner Levels)
                                    </Typography>
                                    <Divider sx={{ height: "2px", mb: 2 }} />
                                    <Grid container spacing={2}>
                                      {/* Black Toner */}
                                      <Grid
                                        item
                                        xs={isMobile ? 12 : 6}
                                        sm={6}
                                        md={3}
                                      >
                                        <TextField
                                          fullWidth
                                          inputProps={{ inputMode: "numeric" }}
                                          label="Black Toner Level"
                                          onChange={(e) => {
                                            handleAssetFieldUpdate(
                                              "tonerStocksAtClient",
                                              {
                                                ...(selectedAssetData.tonerStocksAtClient ||
                                                  {}),
                                                blackToner: e.target.value,
                                              }
                                            );
                                          }}
                                          value={
                                            selectedAssetData
                                              .tonerStocksAtClient
                                              ?.blackToner || ""
                                          }
                                          disabled={
                                            isTicketDoneAndUserNotAdmin ||
                                            assetEditLoading
                                          }
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <div
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "black",
                                                  }}
                                                />
                                              </InputAdornment>
                                            ),
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  onClick={() => {
                                                    handleAssetFieldUpdate(
                                                      "tonerStocksAtClient",
                                                      {
                                                        ...(selectedAssetData.tonerStocksAtClient ||
                                                          {}),
                                                        blackToner: "",
                                                      }
                                                    );
                                                  }}
                                                  disabled={
                                                    isTicketDoneAndUserNotAdmin ||
                                                    assetEditLoading
                                                  }
                                                  size="small"
                                                >
                                                  <CloseIcon />
                                                </IconButton>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </Grid>

                                      {/* Yellow Toner (only for color printers) */}
                                      {selectedAssetData.printerType !==
                                        "black&White" && (
                                          <Grid
                                            item
                                            xs={isMobile ? 12 : 6}
                                            sm={6}
                                            md={3}
                                          >
                                            <TextField
                                              fullWidth
                                              inputProps={{
                                                inputMode: "numeric",
                                              }}
                                              label="Yellow Toner Level"
                                              onChange={(e) => {
                                                handleAssetFieldUpdate(
                                                  "tonerStocksAtClient",
                                                  {
                                                    ...(selectedAssetData.tonerStocksAtClient ||
                                                      {}),
                                                    yellowToner: e.target.value,
                                                  }
                                                );
                                              }}
                                              value={
                                                selectedAssetData
                                                  .tonerStocksAtClient
                                                  ?.yellowToner || ""
                                              }
                                              disabled={
                                                isTicketDoneAndUserNotAdmin ||
                                                assetEditLoading
                                              }
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    <div
                                                      style={{
                                                        height: "20px",
                                                        width: "20px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "yellow",
                                                      }}
                                                    />
                                                  </InputAdornment>
                                                ),
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton
                                                      onClick={() => {
                                                        handleAssetFieldUpdate(
                                                          "tonerStocksAtClient",
                                                          {
                                                            ...(selectedAssetData.tonerStocksAtClient ||
                                                              {}),
                                                            yellowToner: "",
                                                          }
                                                        );
                                                      }}
                                                      disabled={
                                                        isTicketDoneAndUserNotAdmin ||
                                                        assetEditLoading
                                                      }
                                                      size="small"
                                                    >
                                                      <CloseIcon />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </Grid>
                                        )}

                                      {/* Magenta Toner (only for color printers) */}
                                      {selectedAssetData.printerType !==
                                        "black&White" && (
                                          <Grid
                                            item
                                            xs={isMobile ? 12 : 6}
                                            sm={6}
                                            md={3}
                                          >
                                            <TextField
                                              fullWidth
                                              inputProps={{
                                                inputMode: "numeric",
                                              }}
                                              label="Magenta Toner Level"
                                              onChange={(e) => {
                                                handleAssetFieldUpdate(
                                                  "tonerStocksAtClient",
                                                  {
                                                    ...(selectedAssetData.tonerStocksAtClient ||
                                                      {}),
                                                    magentaToner: e.target.value,
                                                  }
                                                );
                                              }}
                                              value={
                                                selectedAssetData
                                                  .tonerStocksAtClient
                                                  ?.magentaToner || ""
                                              }
                                              disabled={
                                                isTicketDoneAndUserNotAdmin ||
                                                assetEditLoading
                                              }
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    <div
                                                      style={{
                                                        height: "20px",
                                                        width: "20px",
                                                        borderRadius: "50%",
                                                        backgroundColor:
                                                          "magenta",
                                                      }}
                                                    />
                                                  </InputAdornment>
                                                ),
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton
                                                      onClick={() => {
                                                        handleAssetFieldUpdate(
                                                          "tonerStocksAtClient",
                                                          {
                                                            ...(selectedAssetData.tonerStocksAtClient ||
                                                              {}),
                                                            magentaToner: "",
                                                          }
                                                        );
                                                      }}
                                                      disabled={
                                                        isTicketDoneAndUserNotAdmin ||
                                                        assetEditLoading
                                                      }
                                                      size="small"
                                                    >
                                                      <CloseIcon />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </Grid>
                                        )}

                                      {/* Cyan Toner (only for color printers) */}
                                      {selectedAssetData.printerType !==
                                        "black&White" && (
                                          <Grid
                                            item
                                            xs={isMobile ? 12 : 6}
                                            sm={6}
                                            md={3}
                                          >
                                            <TextField
                                              fullWidth
                                              inputProps={{
                                                inputMode: "numeric",
                                              }}
                                              label="Cyan Toner Level"
                                              onChange={(e) => {
                                                handleAssetFieldUpdate(
                                                  "tonerStocksAtClient",
                                                  {
                                                    ...(selectedAssetData.tonerStocksAtClient ||
                                                      {}),
                                                    cyanToner: e.target.value,
                                                  }
                                                );
                                              }}
                                              value={
                                                selectedAssetData
                                                  .tonerStocksAtClient
                                                  ?.cyanToner || ""
                                              }
                                              disabled={
                                                isTicketDoneAndUserNotAdmin ||
                                                assetEditLoading
                                              }
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    <div
                                                      style={{
                                                        height: "20px",
                                                        width: "20px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "cyan",
                                                      }}
                                                    />
                                                  </InputAdornment>
                                                ),
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <IconButton
                                                      onClick={() => {
                                                        handleAssetFieldUpdate(
                                                          "tonerStocksAtClient",
                                                          {
                                                            ...(selectedAssetData.tonerStocksAtClient ||
                                                              {}),
                                                            cyanToner: "",
                                                          }
                                                        );
                                                      }}
                                                      disabled={
                                                        isTicketDoneAndUserNotAdmin ||
                                                        assetEditLoading
                                                      }
                                                      size="small"
                                                    >
                                                      <CloseIcon />
                                                    </IconButton>
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                          </Grid>
                                        )}
                                    </Grid>
                                  </Box>
                                )}

                                {/* Save Button for Asset */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    mt: 2,
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveAssetChanges}
                                    disabled={
                                      isTicketDoneAndUserNotAdmin ||
                                      assetEditLoading
                                    }
                                  >
                                    {assetEditLoading
                                      ? "Saving..."
                                      : "Save Asset Changes"}
                                  </Button>
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        )}

                      {/* ASSIGNED USERS */}
                      <Grid item xs={12}>
                        <MultipleUserSelector
                          label="Assigned Technicians"
                          value={existingTicketData.assignedUsers}
                          disableFlag={
                            (sessionUser.role !== "coreAdmin" &&
                              sessionUser.role !== "superAdmin" &&
                              sessionUser.role !== "technicalAdmin" &&
                              sessionUser.role !== "technician" &&
                              sessionUser.role !== "supportAgent") ||
                            isTicketDoneAndUserNotAdmin
                          }
                          required={true}
                          error={!existingTicketData.assignedUsers?.length}
                          onChange={(newValue) => {
                            if (!isTicketDoneAndUserNotAdmin) {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "assignedUsers",
                                  value: newValue,
                                },
                              });
                            }
                          }}
                          companyId={existingTicketData?.company?.value ?? ""}
                        />
                      </Grid>

                      {/* REPORTED USERS */}
                      <Grid item xs={12}>
                        <MultipleUserSelector
                          label={"Reported Users"}
                          value={existingTicketData.reportedUsers}
                          disableFlag={
                            (sessionUser.role !== "coreAdmin" &&
                              sessionUser.role !== "superAdmin" &&
                              sessionUser.role !== "technicalAdmin" &&
                              sessionUser.role !== "technician" &&
                              sessionUser.role !== "technician" &&
                              sessionUser.role !== "supportAgent") ||
                            isTicketDoneAndUserNotAdmin
                          }
                          required={true}
                          error={!existingTicketData.reportedUsers?.length}
                          onChange={(newValue) => {
                            if (!isTicketDoneAndUserNotAdmin) {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "reportedUsers",
                                  value: newValue,
                                },
                              });
                            }
                          }}
                          companyId={existingTicketData?.company?.value ?? ""}
                        />
                      </Grid>

                      {/* COMPLAINANT & COMPLAIN CATEGORY */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Complainant (Optional)"
                          value={existingTicketData.complainant || ""}
                          onChange={(e) =>
                            dispatch({
                              type: "ticketManagement/updateFieldValues",
                              payload: {
                                state: "existingTicket",
                                field: "complainant",
                                value: e.target.value,
                              },
                            })
                          }
                          fullWidth
                          disabled={isTicketDoneAndUserNotAdmin}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {isManualComplainCategory ? (
                          <TextField
                            label="Complain Category"
                            value={existingTicketData.complainCategory || ""}
                            onChange={(e) =>
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "complainCategory",
                                  value: e.target.value,
                                },
                              })
                            }
                            fullWidth
                            disabled={isTicketDoneAndUserNotAdmin}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() =>
                                      setIsManualComplainCategory(false)
                                    }
                                    disabled={isTicketDoneAndUserNotAdmin}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        ) : (
                          <SelectInput
                            label="Complain Category (Optional)"
                            value={existingTicketData.complainCategory || ""}
                            onChange={(e) => {
                              if (e.target.value === "Other") {
                                setIsManualComplainCategory(true);
                                dispatch({
                                  type: "ticketManagement/updateFieldValues",
                                  payload: {
                                    state: "existingTicket",
                                    field: "complainCategory",
                                    value: "",
                                  },
                                });
                              } else {
                                dispatch({
                                  type: "ticketManagement/updateFieldValues",
                                  payload: {
                                    state: "existingTicket",
                                    field: "complainCategory",
                                    value: e.target.value,
                                  },
                                });
                              }
                            }}
                            options={[
                              ...complainCategories.map((c) => ({
                                key: c,
                                name: c,
                              })),
                              { key: "Other", name: "Other" },
                            ]}
                            disabled={isTicketDoneAndUserNotAdmin}
                          />
                        )}
                      </Grid>

                      {/* FILE UPLOADS || ATTACHMENTS */}
                      <Grid
                        item
                        xs={12}
                        sx={{ marginBottom: isMobile ? "16px" : "20px" }}
                      >
                        <FileUploader
                          onFileUploadSuccess={saveUploadedFilesInRedux}
                          onDeleteFile={removeUploadedFileFromRedux}
                          destinationParentFolder="tickets"
                          destinationSubFolder={existingTicketData._id}
                          savedFiles={existingTicketData.uploads}
                          disabled={false}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sx={{
                          marginBottom: isMobile ? "16px" : "20px",
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: { xs: "flex-start", md: "center" },
                          gap: 1,
                        }}
                      >
                        <Chip
                          label={`Created: ${new Date(
                            existingTicketData.createdAt
                          ).toLocaleDateString()} ${isMobile
                            ? ""
                            : new Date(
                              existingTicketData.createdAt
                            ).toLocaleTimeString()
                            }`}
                          color="primary"
                          size={isMobile ? "small" : "medium"}
                          sx={{ fontSize: isMobile ? "0.75rem" : "0.875rem" }}
                        />
                        <Chip
                          label={`By: ${existingTicketData.createdBy?.displayName}`}
                          avatar={
                            <Avatar
                              sx={{
                                width: isMobile ? 20 : 24,
                                height: isMobile ? 20 : 24,
                              }}
                            >
                              {existingTicketData.createdBy?.displayName?.charAt(
                                0
                              )}
                            </Avatar>
                          }
                          size={isMobile ? "small" : "medium"}
                          sx={{ fontSize: isMobile ? "0.75rem" : "0.875rem" }}
                        />
                        <Chip
                          label={`Updated: ${new Date(
                            existingTicketData?.updatedAt
                          ).toLocaleDateString()} ${isMobile
                            ? ""
                            : new Date(
                              existingTicketData?.updatedAt
                            ).toLocaleTimeString()
                            }`}
                          color="secondary"
                          size={isMobile ? "small" : "medium"}
                          sx={{ fontSize: isMobile ? "0.75rem" : "0.875rem" }}
                        />
                        <Chip
                          label={`By: ${existingTicketData.updatedBy?.displayName}`}
                          avatar={
                            <Avatar
                              sx={{
                                width: isMobile ? 20 : 24,
                                height: isMobile ? 20 : 24,
                              }}
                            >
                              {existingTicketData.updatedBy?.displayName?.charAt(
                                0
                              )}
                            </Avatar>
                          }
                          size={isMobile ? "small" : "medium"}
                          sx={{ fontSize: isMobile ? "0.75rem" : "0.875rem" }}
                        />
                      </Grid>

                      {/* STATUS CHANGES TIMELINE */}
                      <Grid item xs={12}>
                        <StyledAccordion
                          expanded={expanded}
                          onChange={handleAccordionChange}
                        >
                          <StyledAccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                style={{ marginRight: "15px", color: "#fff" }}
                              />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Box
                              display="flex"
                              justifyContent="center"
                              width="100%"
                            >
                              <Typography
                                variant={"h6"}
                                sx={{ fontSize: isMobile ? "1rem" : "1.25rem" }}
                              >
                                Status Timeline
                              </Typography>
                            </Box>
                          </StyledAccordionSummary>
                          <StyledAccordionDetails>
                            {existingTicketData?._id && expanded && (
                              <StatusChangesTimeline
                                ticketId={existingTicketData?._id}
                                isExpanded={expanded}
                              />
                            )}
                          </StyledAccordionDetails>
                        </StyledAccordion>
                      </Grid>

                      {/* CHECK-IN/CHECKOUT SECTION */}
                      {((isUserAssigned &&
                        (sessionUser.role === "technician" ||
                          sessionUser.userType === "Admin")) ||
                        ["coreAdmin", "superAdmin", "technicalAdmin"].includes(
                          sessionUser.role
                        )) && (
                          <Grid item xs={12}>
                            <StyledAccordion
                              expanded={checkInExpanded}
                              onChange={(e, isExpanded) =>
                                setCheckInExpanded(isExpanded)
                              }
                            >
                              <StyledAccordionSummary
                                expandIcon={
                                  <ExpandMoreIcon
                                    style={{ marginRight: "15px", color: "#fff" }}
                                  />
                                }
                                aria-controls="checkin-content"
                                id="checkin-header"
                              >
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  width="100%"
                                >
                                  <Typography
                                    variant={"h6"}
                                    sx={{
                                      fontSize: isMobile ? "1rem" : "1.25rem",
                                    }}
                                  >
                                    Check-In/Check-Out
                                  </Typography>
                                </Box>
                              </StyledAccordionSummary>
                              <StyledAccordionDetails>
                                <Box sx={{ width: "100%" }}>
                                  {/* Current Check-In Status */}
                                  {currentCheckIn ? (
                                    <Card
                                      sx={{
                                        mb: isMobile ? 1.5 : 2,
                                        backgroundColor: "#e3f2fd",
                                        border: "1px solid #2196f3",
                                      }}
                                    >
                                      <CardContent sx={{ p: isMobile ? 1.5 : 2 }}>
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            mb: isMobile ? 1.5 : 2,
                                            color: "#1976d2",
                                            fontSize: isMobile
                                              ? "1rem"
                                              : "1.25rem",
                                          }}
                                        >
                                          Currently Checked In
                                        </Typography>
                                        <Stack spacing={1.5}>
                                          <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={1}
                                          >
                                            <AccessTimeIcon color="primary" />
                                            <Typography>
                                              <strong>Checked In:</strong>{" "}
                                              {format(
                                                new Date(
                                                  currentCheckIn.checkInTime
                                                ),
                                                "dd/MM/yyyy hh:mm a"
                                              )}
                                            </Typography>
                                          </Box>
                                          <Box
                                            display="flex"
                                            alignItems="flex-start"
                                            gap={1}
                                          >
                                            <CheckInIcon color="primary" />
                                            <Box>
                                              <Typography>
                                                <strong>Location:</strong>
                                              </Typography>
                                              <Typography variant="body2">
                                                {currentCheckIn.checkInLocation
                                                  ?.address ||
                                                  (currentCheckIn.checkInLocation
                                                    ?.latitude &&
                                                    currentCheckIn.checkInLocation
                                                      ?.longitude
                                                    ? `Lat: ${currentCheckIn.checkInLocation?.latitude}, Lng: ${currentCheckIn.checkInLocation?.longitude}`
                                                    : "Location not available")}
                                              </Typography>
                                            </Box>
                                          </Box>

                                          {/* Commands Input Section - Only shown when checked in */}
                                          <Box sx={{ mt: 2 }}>
                                            <LabelSelector
                                              label="Commands"
                                              value={commands.map(
                                                (cmd) => cmd.label
                                              )}
                                              onChange={handleCommandLabelChange}
                                              disableFlag={false}
                                            />

                                            {/* Show details input for selected commands */}
                                            {commands.map((cmd, index) => (
                                              <Box key={cmd.label} sx={{ mt: 2 }}>
                                                <Box
                                                  display="flex"
                                                  alignItems="center"
                                                  gap={1}
                                                  sx={{
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                      backgroundColor: "#f5f5f5",
                                                    },
                                                    p: 1,
                                                    borderRadius: 1,
                                                  }}
                                                  onClick={() =>
                                                    toggleCommandExpansion(index)
                                                  }
                                                >
                                                  <ExpandMoreIcon
                                                    sx={{
                                                      transform: expandedCommands[
                                                        index
                                                      ]
                                                        ? "rotate(180deg)"
                                                        : "rotate(0deg)",
                                                      transition:
                                                        "transform 0.2s",
                                                    }}
                                                  />
                                                  <Typography
                                                    variant="body1"
                                                    sx={{
                                                      fontWeight: "medium",
                                                      flex: 1,
                                                    }}
                                                  >
                                                    {labels.find(
                                                      (l) => l.value === cmd.label
                                                    )?.label || cmd.label}
                                                  </Typography>
                                                </Box>
                                                {expandedCommands[index] && (
                                                  <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    placeholder={`Enter details for ${labels.find(
                                                      (l) =>
                                                        l.value === cmd.label
                                                    )?.label || cmd.label
                                                      }`}
                                                    value={cmd.details || ""}
                                                    onChange={(e) =>
                                                      updateCommandDetails(
                                                        cmd.label,
                                                        e.target.value
                                                      )
                                                    }
                                                    size="small"
                                                    sx={{ mt: 1 }}
                                                  />
                                                )}
                                              </Box>
                                            ))}

                                            <Box
                                              display="flex"
                                              gap={1}
                                              sx={{
                                                mt: 2,
                                                flexDirection: isMobile
                                                  ? "column"
                                                  : "row",
                                              }}
                                            >
                                              <Button
                                                variant="contained"
                                                size={
                                                  isMobile ? "medium" : "small"
                                                }
                                                onClick={handleSaveCommands}
                                                disabled={
                                                  existingTicketData.isLoading
                                                }
                                                fullWidth={isMobile}
                                              >
                                                Save Commands
                                              </Button>
                                              <Button
                                                variant="outlined"
                                                size={
                                                  isMobile ? "medium" : "small"
                                                }
                                                onClick={() =>
                                                  setShowInventoryModal(true)
                                                }
                                                fullWidth={isMobile}
                                              >
                                                Open Inventory
                                              </Button>
                                            </Box>
                                          </Box>

                                          {/* Display selected inventory items - same style as commands */}
                                          {selectedInventoryItems.length > 0 && (
                                            <Box sx={{ mt: 2 }}>
                                              <Typography sx={{ mb: 1 }}>
                                                <strong>
                                                  Selected Inventory Items:
                                                </strong>
                                              </Typography>
                                              {selectedInventoryItems.map(
                                                (item, idx) => (
                                                  <Box
                                                    key={idx}
                                                    sx={{
                                                      mb: 1,
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 1,
                                                    }}
                                                  >
                                                    <Box
                                                      sx={{
                                                        backgroundColor:
                                                          "#e3f2fd",
                                                        padding: "8px 12px",
                                                        borderRadius: "4px",
                                                        border:
                                                          "1px solid #90caf9",
                                                        flex: 1,
                                                      }}
                                                    >
                                                      <Typography variant="body2">
                                                        {idx + 1}.{" "}
                                                        {item.inventoryItem
                                                          ?.itemName ||
                                                          "Unknown"}{" "}
                                                        - Qty: {item.quantity}
                                                        {item.inventoryItem
                                                          ?.assetType?.name &&
                                                          ` (${item.inventoryItem.assetType.name})`}
                                                      </Typography>
                                                    </Box>
                                                    <IconButton
                                                      onClick={() =>
                                                        removeInventoryItem(idx)
                                                      }
                                                      color="error"
                                                      size="small"
                                                    >
                                                      <CloseIcon />
                                                    </IconButton>
                                                  </Box>
                                                )
                                              )}
                                            </Box>
                                          )}

                                          {/* Display saved commands */}
                                          {currentCheckIn.commands &&
                                            Array.isArray(
                                              currentCheckIn.commands
                                            ) &&
                                            currentCheckIn.commands.length >
                                            0 && (
                                              <Box>
                                                <Typography sx={{ mb: 1 }}>
                                                  <strong>Saved Commands:</strong>
                                                </Typography>
                                                <Box
                                                  sx={{
                                                    backgroundColor: "#f5f5f5",
                                                    padding: "12px",
                                                    borderRadius: "4px",
                                                    border: "1px solid #e0e0e0",
                                                  }}
                                                >
                                                  {currentCheckIn.commands.map(
                                                    (cmd, idx) => {
                                                      // Handle both old format (string) and new format (object)
                                                      // Safety check: ensure cmd is not null/undefined
                                                      if (!cmd) return null;

                                                      // Extract label - handle string or object format
                                                      let commandLabel = "";
                                                      let commandDetails = "";

                                                      if (
                                                        typeof cmd === "string"
                                                      ) {
                                                        commandLabel = cmd;
                                                      } else if (
                                                        cmd &&
                                                        typeof cmd === "object"
                                                      ) {
                                                        commandLabel =
                                                          cmd.label || "";
                                                        commandDetails =
                                                          cmd.details || "";
                                                      }

                                                      // Skip if no label
                                                      if (!commandLabel)
                                                        return null;

                                                      const labelObj =
                                                        labels.find(
                                                          (l) =>
                                                            l.value ===
                                                            commandLabel
                                                        );
                                                      return (
                                                        <Box
                                                          key={idx}
                                                          sx={{
                                                            mb:
                                                              idx <
                                                                currentCheckIn
                                                                  .commands.length -
                                                                1
                                                                ? 2
                                                                : 0,
                                                          }}
                                                        >
                                                          <Typography
                                                            variant="subtitle2"
                                                            sx={{
                                                              fontWeight: "bold",
                                                              mb: commandDetails
                                                                ? 0.5
                                                                : 0,
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: 0.5,
                                                            }}
                                                          >
                                                            {labelObj?.icon}
                                                            {labelObj?.label ||
                                                              commandLabel}
                                                          </Typography>
                                                          {commandDetails && (
                                                            <Typography
                                                              variant="body2"
                                                              sx={{
                                                                ml: 3,
                                                                whiteSpace:
                                                                  "pre-wrap",
                                                                wordBreak:
                                                                  "break-word",
                                                                color:
                                                                  "text.secondary",
                                                              }}
                                                            >
                                                              {commandDetails}
                                                            </Typography>
                                                          )}
                                                        </Box>
                                                      );
                                                    }
                                                  )}
                                                </Box>
                                              </Box>
                                            )}

                                          {/* File Upload Section for Check-In */}
                                          <Box sx={{ mt: 2 }}>
                                            <Typography
                                              sx={{ mb: 1, fontWeight: "bold" }}
                                            >
                                              Attachments
                                            </Typography>
                                            <FileUploader
                                              onFileUploadSuccess={(fileData) => {
                                                const newFiles = [
                                                  ...checkInFiles,
                                                  fileData,
                                                ];
                                                setCheckInFiles(newFiles);
                                                // Update current check-in with files
                                                if (currentCheckIn) {
                                                  const updatedCheckIn = {
                                                    ...currentCheckIn,
                                                    files: newFiles,
                                                  };
                                                  setCurrentCheckIn(
                                                    updatedCheckIn
                                                  );
                                                  // Update ticket state
                                                  const updatedCheckInCheckOut = (
                                                    existingTicketData.checkInCheckOut ||
                                                    []
                                                  ).map((checkIn) => {
                                                    if (
                                                      checkIn._id ===
                                                      currentCheckIn._id
                                                    ) {
                                                      return updatedCheckIn;
                                                    }
                                                    return checkIn;
                                                  });
                                                  dispatch({
                                                    type: "ticketManagement/updateFieldValues",
                                                    payload: {
                                                      state: "existingTicket",
                                                      field: "checkInCheckOut",
                                                      value:
                                                        updatedCheckInCheckOut,
                                                    },
                                                  });
                                                }
                                              }}
                                              onDeleteFile={(fileName) => {
                                                const updatedFiles =
                                                  checkInFiles.filter(
                                                    (file) =>
                                                      file.filename !== fileName
                                                  );
                                                setCheckInFiles(updatedFiles);
                                                // Update current check-in with files
                                                if (currentCheckIn) {
                                                  const updatedCheckIn = {
                                                    ...currentCheckIn,
                                                    files: updatedFiles,
                                                  };
                                                  setCurrentCheckIn(
                                                    updatedCheckIn
                                                  );
                                                  // Update ticket state
                                                  const updatedCheckInCheckOut = (
                                                    existingTicketData.checkInCheckOut ||
                                                    []
                                                  ).map((checkIn) => {
                                                    if (
                                                      checkIn._id ===
                                                      currentCheckIn._id
                                                    ) {
                                                      return updatedCheckIn;
                                                    }
                                                    return checkIn;
                                                  });
                                                  dispatch({
                                                    type: "ticketManagement/updateFieldValues",
                                                    payload: {
                                                      state: "existingTicket",
                                                      field: "checkInCheckOut",
                                                      value:
                                                        updatedCheckInCheckOut,
                                                    },
                                                  });
                                                }
                                              }}
                                              destinationParentFolder="tickets"
                                              destinationSubFolder={`${existingTicketData._id}/checkin-checkout`}
                                              savedFiles={checkInFiles}
                                              disabled={false}
                                              allowDeleteForAll={true}
                                              setAdminOnly={true}
                                            />
                                          </Box>

                                          <Button
                                            variant="contained"
                                            color="error"
                                            startIcon={<CheckOutIcon />}
                                            onClick={handleCheckOutClick}
                                            disabled={
                                              isGettingLocation ||
                                              existingTicketData.isLoading
                                            }
                                            sx={{ mt: 1 }}
                                            fullWidth
                                          >
                                            {isGettingLocation
                                              ? "Getting Location..."
                                              : "Check Out"}
                                          </Button>
                                        </Stack>
                                      </CardContent>
                                    </Card>
                                  ) : (
                                    <Card
                                      sx={{
                                        mb: isMobile ? 1.5 : 2,
                                        backgroundColor: "#fff3e0",
                                        border: "1px solid #ff9800",
                                      }}
                                    >
                                      <CardContent sx={{ p: isMobile ? 1.5 : 2 }}>
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            mb: isMobile ? 1.5 : 2,
                                            color: "#f57c00",
                                            fontSize: isMobile
                                              ? "1rem"
                                              : "1.25rem",
                                          }}
                                        >
                                          Not Checked In
                                        </Typography>
                                        <Stack spacing={2}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CheckInIcon />}
                                            onClick={handleCheckInClick}
                                            disabled={
                                              isGettingLocation ||
                                              existingTicketData.isLoading
                                            }
                                            fullWidth
                                            size={isMobile ? "medium" : "large"}
                                          >
                                            {isGettingLocation
                                              ? "Getting Location..."
                                              : "Check In"}
                                          </Button>
                                        </Stack>
                                      </CardContent>
                                    </Card>
                                  )}

                                  {/* Check-In/Check-Out History */}
                                  {existingTicketData?.checkInCheckOut &&
                                    existingTicketData.checkInCheckOut.length >
                                    0 && (
                                      <Box sx={{ mt: isMobile ? 2 : 3 }}>
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            mb: isMobile ? 1.5 : 2,
                                            fontSize: isMobile
                                              ? "1rem"
                                              : "1.25rem",
                                          }}
                                        >
                                          Check-In/Check-Out History
                                        </Typography>
                                        <Stack spacing={2}>
                                          {[...existingTicketData.checkInCheckOut]
                                            .sort(
                                              (a, b) =>
                                                new Date(b.checkInTime) -
                                                new Date(a.checkInTime)
                                            )
                                            .map((record, index) => (
                                              <Card
                                                key={index}
                                                sx={{
                                                  backgroundColor:
                                                    record.isCheckedOut
                                                      ? "#f5f5f5"
                                                      : "#e8f5e9",
                                                  mb: isMobile ? 1 : 1.5,
                                                }}
                                              >
                                                <CardContent
                                                  sx={{ p: isMobile ? 1.5 : 2 }}
                                                >
                                                  <Stack spacing={1.5}>
                                                    <Box
                                                      display="flex"
                                                      justifyContent="space-between"
                                                      alignItems="center"
                                                    >
                                                      <Typography
                                                        variant="subtitle1"
                                                        fontWeight="bold"
                                                      >
                                                        {record.isCheckedOut
                                                          ? "Completed"
                                                          : "Active"}
                                                      </Typography>
                                                      <Chip
                                                        label={
                                                          record.isCheckedOut
                                                            ? "Checked Out"
                                                            : "Checked In"
                                                        }
                                                        color={
                                                          record.isCheckedOut
                                                            ? "default"
                                                            : "success"
                                                        }
                                                        size="small"
                                                      />
                                                    </Box>
                                                    <Typography variant="body2">
                                                      <strong>By:</strong>{" "}
                                                      {record.checkedInBy
                                                        ?.displayName ||
                                                        `${record.checkedInBy?.firstName} ${record.checkedInBy?.lastName}`}
                                                    </Typography>
                                                    <Box>
                                                      <Typography variant="body2">
                                                        <strong>Check-In:</strong>{" "}
                                                        {format(
                                                          new Date(
                                                            record.checkInTime
                                                          ),
                                                          "dd/MM/yyyy hh:mm a"
                                                        )}
                                                      </Typography>
                                                      <Typography
                                                        variant="body2"
                                                        sx={{ ml: 2 }}
                                                      >
                                                        {record.checkInLocation
                                                          ?.address ||
                                                          (record.checkInLocation
                                                            ?.latitude &&
                                                            record.checkInLocation
                                                              ?.longitude
                                                            ? `Lat: ${record.checkInLocation?.latitude}, Lng: ${record.checkInLocation?.longitude}`
                                                            : "Location not available")}
                                                      </Typography>
                                                    </Box>
                                                    {record.isCheckedOut && (
                                                      <>
                                                        <Box>
                                                          <Typography variant="body2">
                                                            <strong>
                                                              Check-Out:
                                                            </strong>{" "}
                                                            {format(
                                                              new Date(
                                                                record.checkoutTime
                                                              ),
                                                              "dd/MM/yyyy hh:mm a"
                                                            )}
                                                          </Typography>
                                                          <Typography
                                                            variant="body2"
                                                            sx={{ ml: 2 }}
                                                          >
                                                            {record
                                                              .checkoutLocation
                                                              ?.address ||
                                                              (record
                                                                .checkoutLocation
                                                                ?.latitude &&
                                                                record
                                                                  .checkoutLocation
                                                                  ?.longitude
                                                                ? `Lat: ${record.checkoutLocation?.latitude}, Lng: ${record.checkoutLocation?.longitude}`
                                                                : "Location not available")}
                                                          </Typography>
                                                        </Box>
                                                        <Box>
                                                          <Typography variant="body2">
                                                            <strong>
                                                              Duration:
                                                            </strong>{" "}
                                                            {(() => {
                                                              const start = new Date(record.checkInTime);
                                                              const end = new Date(record.checkoutTime);
                                                              const diffMs = end - start;
                                                              const totalMinutes = Math.floor(diffMs / (1000 * 60));
                                                              const hours = Math.floor(totalMinutes / 60);
                                                              const days = Math.floor(hours / 24);
                                                              const remHours = hours % 24;
                                                              const remMinutes = totalMinutes % 60;

                                                              let parts = [];
                                                              if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
                                                              if (remHours > 0) parts.push(`${remHours} h`);
                                                              if (remMinutes > 0) parts.push(`${remMinutes} minute${remMinutes > 1 ? "s" : ""}`);

                                                              if (parts.length === 0) return "Less than a minute";
                                                              if (parts.length === 1) return parts[0];
                                                              const lastPart = parts.pop();
                                                              return `${parts.join(", ")} and ${lastPart}`;
                                                            })()}
                                                          </Typography>
                                                        </Box>
                                                      </>
                                                    )}
                                                    {/* Display Files for this check-in/checkout */}
                                                    {record.files &&
                                                      Array.isArray(
                                                        record.files
                                                      ) &&
                                                      record.files.length > 0 && (
                                                        <Box sx={{ mt: 1 }}>
                                                          <Typography
                                                            variant="body2"
                                                            sx={{
                                                              fontWeight: "bold",
                                                              mb: 0.5,
                                                            }}
                                                          >
                                                            Attachments (
                                                            {record.files.length}
                                                            ):
                                                          </Typography>
                                                          <Box
                                                            sx={{
                                                              display: "flex",
                                                              flexWrap: "wrap",
                                                              gap: 1,
                                                              ml: 1,
                                                            }}
                                                          >
                                                            {record.files
                                                              .filter(
                                                                (file) =>
                                                                  !(
                                                                    sessionUser.role ===
                                                                    "customerUser" &&
                                                                    file.type ===
                                                                    "proposal"
                                                                  )
                                                              )
                                                              .filter(
                                                                (file) =>
                                                                  !(
                                                                    file.isAdminOnlyFile ===
                                                                    true &&
                                                                    sessionUser.userType !==
                                                                    "Admin"
                                                                  )
                                                              )
                                                              .map(
                                                                (
                                                                  file,
                                                                  fileIndex
                                                                ) => {
                                                                  const handleFileView =
                                                                    async () => {
                                                                      try {
                                                                        const fileId =
                                                                          file._id ||
                                                                          file.id ||
                                                                          file;
                                                                        if (
                                                                          !fileId
                                                                        ) {
                                                                          toast.error(
                                                                            "File ID not found",
                                                                            {
                                                                              position:
                                                                                toast
                                                                                  .POSITION
                                                                                  .TOP_CENTER,
                                                                              autoClose: 3000,
                                                                            }
                                                                          );
                                                                          return;
                                                                        }
                                                                        const baseURL =
                                                                          process
                                                                            .env
                                                                            .REACT_APP_BASE_URL;
                                                                        const response =
                                                                          await fetch(
                                                                            `${baseURL}files/downloadFileProxyApi/${fileId}`,
                                                                            {
                                                                              method:
                                                                                "GET",
                                                                              credentials:
                                                                                "include",
                                                                            }
                                                                          );
                                                                        if (
                                                                          !response.ok
                                                                        ) {
                                                                          throw new Error(
                                                                            "Failed to download file"
                                                                          );
                                                                        }
                                                                        const blob =
                                                                          await response.blob();
                                                                        const blobURL =
                                                                          URL.createObjectURL(
                                                                            blob
                                                                          );
                                                                        window.open(
                                                                          blobURL,
                                                                          "_blank"
                                                                        );
                                                                        // Clean up the blob URL after a delay
                                                                        setTimeout(
                                                                          () =>
                                                                            URL.revokeObjectURL(
                                                                              blobURL
                                                                            ),
                                                                          100
                                                                        );
                                                                      } catch (error) {
                                                                        console.error(
                                                                          "Error viewing file:",
                                                                          error
                                                                        );
                                                                        toast.error(
                                                                          "Failed to view file",
                                                                          {
                                                                            position:
                                                                              toast
                                                                                .POSITION
                                                                                .TOP_CENTER,
                                                                            autoClose: 3000,
                                                                          }
                                                                        );
                                                                      }
                                                                    };
                                                                  return (
                                                                    <Chip
                                                                      key={
                                                                        fileIndex
                                                                      }
                                                                      label={
                                                                        file.filename ||
                                                                        file.originalname ||
                                                                        "File"
                                                                      }
                                                                      onClick={
                                                                        handleFileView
                                                                      }
                                                                      sx={{
                                                                        cursor:
                                                                          "pointer",
                                                                        "&:hover":
                                                                        {
                                                                          backgroundColor:
                                                                            "#e0e0e0",
                                                                        },
                                                                      }}
                                                                      size="small"
                                                                    />
                                                                  );
                                                                }
                                                              )}
                                                          </Box>
                                                        </Box>
                                                      )}
                                                    {record.commands &&
                                                      Array.isArray(
                                                        record.commands
                                                      ) &&
                                                      record.commands.length >
                                                      0 && (
                                                        <Box>
                                                          <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1 }}
                                                          >
                                                            <strong>
                                                              Commands:
                                                            </strong>
                                                          </Typography>
                                                          <Box
                                                            sx={{
                                                              backgroundColor:
                                                                "#fafafa",
                                                              padding: "10px",
                                                              borderRadius: "4px",
                                                              border:
                                                                "1px solid #e0e0e0",
                                                              ml: 1,
                                                            }}
                                                          >
                                                            {record.commands.map(
                                                              (cmd, idx) => {
                                                                // Handle both old format (string) and new format (object)
                                                                // Safety check: ensure cmd is not null/undefined
                                                                if (!cmd)
                                                                  return null;

                                                                // Extract label - handle string or object format
                                                                let commandLabel =
                                                                  "";
                                                                let commandDetails =
                                                                  "";

                                                                if (
                                                                  typeof cmd ===
                                                                  "string"
                                                                ) {
                                                                  commandLabel =
                                                                    cmd;
                                                                } else if (
                                                                  cmd &&
                                                                  typeof cmd ===
                                                                  "object"
                                                                ) {
                                                                  commandLabel =
                                                                    cmd.label ||
                                                                    "";
                                                                  commandDetails =
                                                                    cmd.details ||
                                                                    "";
                                                                }

                                                                // Skip if no label
                                                                if (!commandLabel)
                                                                  return null;

                                                                const labelObj =
                                                                  labels.find(
                                                                    (l) =>
                                                                      l.value ===
                                                                      commandLabel
                                                                  );
                                                                return (
                                                                  <Box
                                                                    key={idx}
                                                                    sx={{
                                                                      mb:
                                                                        idx <
                                                                          record
                                                                            .commands
                                                                            .length -
                                                                          1
                                                                          ? 2
                                                                          : 0,
                                                                    }}
                                                                  >
                                                                    <Typography
                                                                      variant="subtitle2"
                                                                      sx={{
                                                                        fontWeight:
                                                                          "bold",
                                                                        mb: commandDetails
                                                                          ? 0.5
                                                                          : 0,
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        gap: 0.5,
                                                                        color:
                                                                          "text.primary",
                                                                      }}
                                                                    >
                                                                      {
                                                                        labelObj?.icon
                                                                      }
                                                                      {labelObj?.label ||
                                                                        commandLabel}
                                                                    </Typography>
                                                                    {commandDetails && (
                                                                      <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                          ml: 3,
                                                                          whiteSpace:
                                                                            "pre-wrap",
                                                                          wordBreak:
                                                                            "break-word",
                                                                          color:
                                                                            "text.secondary",
                                                                        }}
                                                                      >
                                                                        {
                                                                          commandDetails
                                                                        }
                                                                      </Typography>
                                                                    )}
                                                                  </Box>
                                                                );
                                                              }
                                                            )}
                                                          </Box>
                                                        </Box>
                                                      )}
                                                    {record.usedInventoryItems &&
                                                      record.usedInventoryItems
                                                        .length > 0 && (
                                                        <Box>
                                                          <Typography
                                                            variant="body2"
                                                            sx={{ mb: 1 }}
                                                          >
                                                            <strong>
                                                              Used Inventory
                                                              Items:
                                                            </strong>
                                                          </Typography>
                                                          <Box
                                                            sx={{
                                                              backgroundColor:
                                                                "#e3f2fd",
                                                              padding: "10px",
                                                              borderRadius: "4px",
                                                              border:
                                                                "1px solid #90caf9",
                                                              ml: 1,
                                                            }}
                                                          >
                                                            {record.usedInventoryItems.map(
                                                              (item, idx) => (
                                                                <Typography
                                                                  key={idx}
                                                                  variant="body2"
                                                                  sx={{
                                                                    mb:
                                                                      idx <
                                                                        record
                                                                          .usedInventoryItems
                                                                          .length -
                                                                        1
                                                                        ? 1
                                                                        : 0,
                                                                    whiteSpace:
                                                                      "pre-wrap",
                                                                    wordBreak:
                                                                      "break-word",
                                                                    color:
                                                                      "text.secondary",
                                                                  }}
                                                                >
                                                                  {idx + 1}.{" "}
                                                                  {item
                                                                    .inventoryItem
                                                                    ?.itemName ||
                                                                    "Unknown Item"}{" "}
                                                                  - Qty:{" "}
                                                                  {item.quantity}
                                                                  {item
                                                                    .inventoryItem
                                                                    ?.assetType
                                                                    ?.name &&
                                                                    ` (${item.inventoryItem.assetType.name}`}
                                                                  {item
                                                                    .inventoryItem
                                                                    ?.brand
                                                                    ?.name &&
                                                                    ` - ${item.inventoryItem.brand.name}`}
                                                                  {item
                                                                    .inventoryItem
                                                                    ?.model
                                                                    ?.name &&
                                                                    ` - ${item.inventoryItem.model.name}`}
                                                                  {item
                                                                    .inventoryItem
                                                                    ?.assetType
                                                                    ?.name && ")"}
                                                                </Typography>
                                                              )
                                                            )}
                                                          </Box>
                                                        </Box>
                                                      )}
                                                  </Stack>
                                                </CardContent>
                                              </Card>
                                            ))}
                                        </Stack>
                                      </Box>
                                    )}
                                </Box>
                              </StyledAccordionDetails>
                            </StyledAccordion>
                          </Grid>
                        )}

                      {/* COMMENTS & ACTIVITIES SECTION */}
                      <Grid
                        item
                        xs={12}
                        sx={{ marginBottom: isMobile ? "8px" : "10px" }}
                      >
                        <Grid container spacing={isMobile ? 0.5 : 1}>
                          <Grid item xs={12} sm={6}>
                            {/* CHIPS TO SWITCH B/W COMMENTS & ACTIVITIES */}
                            <Stack
                              direction="row"
                              spacing={1}
                              sx={{ flexWrap: "wrap", gap: 1 }}
                            >
                              {
                                // Render activities only the current session user is a superAdmin
                                sessionUser.userType === "Admin" && (
                                  <Chip
                                    label="Internal Comments"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                      borderRadius: "7px",
                                      backgroundColor:
                                        toggleCommentsAndActivities ===
                                          "Internal Comments"
                                          ? "#8EACCD"
                                          : "",
                                      fontWeight: 600,
                                      fontSize: isMobile
                                        ? "0.75rem"
                                        : "0.875rem",
                                    }}
                                    onClick={() =>
                                      setToggleCommentsAndActivities(
                                        "Internal Comments"
                                      )
                                    }
                                  />
                                )
                              }
                              <Chip
                                label="Customer Comments"
                                size={isMobile ? "small" : "medium"}
                                sx={{
                                  borderRadius: "7px",
                                  backgroundColor:
                                    toggleCommentsAndActivities ===
                                      "Customer Comments"
                                      ? "#8EACCD"
                                      : "",
                                  fontWeight: 600,
                                  fontSize: isMobile ? "0.75rem" : "0.875rem",
                                }}
                                onClick={() =>
                                  setToggleCommentsAndActivities(
                                    "Customer Comments"
                                  )
                                }
                              />
                              {
                                // Render activities only the current session user is a superAdmin
                                (sessionUser.role === "coreAdmin" ||
                                  sessionUser.role === "superAdmin" ||
                                  sessionUser.role === "technicalAdmin" ||
                                  sessionUser.role === "technician") && (
                                  <Chip
                                    label="Activities"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                      borderRadius: "7px",
                                      backgroundColor:
                                        toggleCommentsAndActivities ===
                                          "activities"
                                          ? "#8EACCD"
                                          : "",
                                      fontWeight: 600,
                                      fontSize: isMobile
                                        ? "0.75rem"
                                        : "0.875rem",
                                    }}
                                    onClick={() =>
                                      setToggleCommentsAndActivities(
                                        "activities"
                                      )
                                    }
                                  />
                                )
                              }
                            </Stack>
                          </Grid>

                          {toggleCommentsAndActivities ===
                            "Internal Comments" && (
                              <>
                                {/* ADD COMMENT BOX */}
                                <Grid item xs={12}>
                                  <Stack
                                    direction={"row"}
                                    spacing={1.5}
                                    sx={{ marginTop: "10px" }}
                                  >
                                    <Avatar
                                      alt="User Avatar"
                                      src={sessionUser.photoURL}
                                      style={{
                                        marginRight: "8px",
                                        marginTop: "4px",
                                        backgroundColor: sessionUser.photoURL
                                          ? "transparent"
                                          : sessionUser.displayName
                                            ? stringToColor(sessionUser.displayName)
                                            : stringToColor(
                                              `${sessionUser.firstName} ${sessionUser.lastName}`
                                            ),
                                      }}
                                    >
                                      {!sessionUser.photoURL &&
                                        (sessionUser.displayName ||
                                          sessionUser.firstName)
                                        ? sessionUser.displayName
                                          ? sessionUser.displayName[0]
                                          : sessionUser.firstName[0]
                                        : null}
                                    </Avatar>

                                    {!existingTicketData.isCommentSubmitInProgress ? (
                                      <TextField
                                        id="new-comment-add-textbox"
                                        label="Add an Internal Comment"
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        maxRows={10}
                                        value={existingTicketData.newComment}
                                        onChange={(e) => {
                                          dispatch({
                                            type: "ticketManagement/updateFieldValues",
                                            payload: {
                                              state: "existingTicket",
                                              field: "newComment",
                                              value: e.target.value,
                                            },
                                          });
                                        }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              onClick={() =>
                                                dispatch(
                                                  addInternalCommentsToTicket({
                                                    ticketId:
                                                      existingTicketData._id,
                                                    commentString:
                                                      existingTicketData.newComment,
                                                  })
                                                )
                                              }
                                            >
                                              <IconButton>
                                                <SendRoundedIcon />
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    ) : (
                                      <Skeleton
                                        variant="rect"
                                        sx={{ boarderRadius: `10px` }}
                                        width="100%"
                                        height="60px"
                                        component="div"
                                      />
                                    )}
                                  </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                  {existingTicketData?.internalComments
                                    .slice()
                                    .sort(
                                      (a, b) =>
                                        new Date(b.createdAt) -
                                        new Date(a.createdAt)
                                    )
                                    .map((comment, index) => (
                                      <Card
                                        key={`card-${index}`}
                                        sx={{
                                          margin: 0.5,
                                          backgroundColor: "lightgray", // Customize the background color
                                          border: "1px solid #ccc", // Add a border
                                          borderRadius: "4px", // Add some border radius
                                          "&:hover": {
                                            backgroundColor: "#d9d9d9", // Change background color on hover
                                          },
                                        }}
                                      >
                                        <CardHeader
                                          avatar={
                                            <Avatar
                                              alt="Commented User"
                                              src={comment?.user?.photoURL}
                                              sx={{
                                                marginRight: "8px",
                                                marginTop: "4px",
                                                backgroundColor: comment?.user
                                                  ?.photoURL
                                                  ? "transparent"
                                                  : comment?.user?.displayName
                                                    ? stringToColor(
                                                      comment.user.displayName
                                                    )
                                                    : stringToColor(
                                                      `${comment?.user?.firstName} ${comment?.user?.lastName}`
                                                    ),
                                              }}
                                            >
                                              {!comment?.user?.photoURL &&
                                                (comment?.user?.displayName ||
                                                  comment?.user?.firstName)
                                                ? comment?.user?.displayName
                                                  ? comment?.user?.displayName[0]
                                                  : comment?.user?.firstName[0]
                                                : null}
                                            </Avatar>
                                          }
                                          title={
                                            comment?.user?.displayName ??
                                            `${comment?.user?.firstName} ${comment?.user?.lastName}`
                                          }
                                          subheader={formatDate(
                                            comment.createdAt
                                          )} // Format the date and time
                                        />
                                        <CardContent sx={{ paddingTop: "0" }}>
                                          {" "}
                                          {/* Reduce the top padding */}
                                          <Typography variant="body1">
                                            {comment.comment}
                                          </Typography>
                                        </CardContent>
                                      </Card>
                                    ))}
                                </Grid>
                              </>
                            )}

                          {toggleCommentsAndActivities ===
                            "Customer Comments" && (
                              <>
                                {/* ADD COMMENT BOX */}
                                <Grid item xs={12}>
                                  <Stack
                                    direction={"row"}
                                    spacing={1.5}
                                    sx={{ marginTop: "10px" }}
                                  >
                                    <Avatar
                                      alt="User Avatar"
                                      src={sessionUser.photoURL}
                                      style={{
                                        marginRight: "8px",
                                        marginTop: "4px",
                                        backgroundColor: sessionUser.photoURL
                                          ? "transparent"
                                          : sessionUser.displayName
                                            ? stringToColor(sessionUser.displayName)
                                            : stringToColor(
                                              `${sessionUser.firstName} ${sessionUser.lastName}`
                                            ),
                                      }}
                                    >
                                      {!sessionUser.photoURL &&
                                        (sessionUser.displayName ||
                                          sessionUser.firstName)
                                        ? sessionUser.displayName
                                          ? sessionUser.displayName[0]
                                          : sessionUser.firstName[0]
                                        : null}
                                    </Avatar>

                                    {!existingTicketData.isCommentSubmitInProgress ? (
                                      <TextField
                                        id="new-comment-add-textbox"
                                        label="Add a Comment"
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        maxRows={10}
                                        value={existingTicketData.newComment}
                                        onChange={(e) => {
                                          dispatch({
                                            type: "ticketManagement/updateFieldValues",
                                            payload: {
                                              state: "existingTicket",
                                              field: "newComment",
                                              value: e.target.value,
                                            },
                                          });
                                        }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment
                                              position="end"
                                              onClick={() =>
                                                dispatch(
                                                  addCommentToTicket({
                                                    ticketId:
                                                      existingTicketData._id,
                                                    commentString:
                                                      existingTicketData.newComment,
                                                  })
                                                )
                                              }
                                            >
                                              <IconButton>
                                                <SendRoundedIcon />
                                              </IconButton>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    ) : (
                                      <Skeleton
                                        variant="rect"
                                        sx={{ boarderRadius: `10px` }}
                                        width="100%"
                                        height="60px"
                                        component="div"
                                      />
                                    )}
                                  </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                  {existingTicketData?.comments
                                    .slice()
                                    .sort(
                                      (a, b) =>
                                        new Date(b.createdAt) -
                                        new Date(a.createdAt)
                                    )
                                    .map((comment, index) => (
                                      <Card
                                        key={`card-${index}`}
                                        sx={{
                                          margin: 0.5,
                                          backgroundColor: "lightgray", // Customize the background color
                                          border: "1px solid #ccc", // Add a border
                                          borderRadius: "4px", // Add some border radius
                                          "&:hover": {
                                            backgroundColor: "#d9d9d9", // Change background color on hover
                                          },
                                        }}
                                      >
                                        <CardHeader
                                          avatar={
                                            <Avatar
                                              alt="Commented User"
                                              src={comment?.user?.photoURL}
                                              sx={{
                                                marginRight: "8px",
                                                marginTop: "4px",
                                                backgroundColor: comment?.user
                                                  ?.photoURL
                                                  ? "transparent"
                                                  : comment?.user?.displayName
                                                    ? stringToColor(
                                                      comment.user.displayName
                                                    )
                                                    : stringToColor(
                                                      `${comment?.user?.firstName} ${comment?.user?.lastName}`
                                                    ),
                                              }}
                                            >
                                              {!comment?.user?.photoURL &&
                                                (comment?.user?.displayName ||
                                                  comment?.user?.firstName)
                                                ? comment?.user?.displayName
                                                  ? comment?.user?.displayName[0]
                                                  : comment?.user?.firstName[0]
                                                : null}
                                            </Avatar>
                                          }
                                          title={
                                            comment?.user?.displayName ??
                                            `${comment?.user?.firstName} ${comment?.user?.lastName}`
                                          }
                                          subheader={formatDate(
                                            comment.createdAt
                                          )} // Format the date and time
                                        />
                                        <CardContent sx={{ paddingTop: "0" }}>
                                          {" "}
                                          {/* Reduce the top padding */}
                                          <Typography variant="body1">
                                            {comment.comment}
                                          </Typography>
                                        </CardContent>
                                      </Card>
                                    ))}
                                </Grid>
                              </>
                            )}

                          {toggleCommentsAndActivities === "activities" && (
                            <>
                              {/* Activities Section */}
                              <Grid item xs={12}>
                                <Box>
                                  {existingTicketData.activities?.length ? (
                                    existingTicketData.activities.map(
                                      (log, index) => (
                                        <Paper
                                          key={`activity-${index}`}
                                          sx={{
                                            p: 2,
                                            m: 1,
                                            backgroundColor: "lightgray", // Customize the background color
                                            border: "1px solid #ccc", // Add a border
                                            borderRadius: "4px", // Add some border radius
                                            "&:hover": {
                                              backgroundColor: "#d9d9d9", // Change background color on hover
                                            },
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            color="textSecondary"
                                          >
                                            {new Date(
                                              log.createdAt
                                            ).toLocaleString()}{" "}
                                            {/* Format the date and time */}
                                          </Typography>
                                          <Typography variant="body1">
                                            {log.activityString}
                                          </Typography>
                                        </Paper>
                                      )
                                    )
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      color="textSecondary"
                                    >
                                      No activities to display.
                                    </Typography>
                                  )}
                                </Box>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {existingTicketData.isLoading && <TicketModalSkeleton />}
                </Grid>
                <DeclineDialog
                  open={declineModaleOpen}
                  handleClose={setDeclineModalOpen}
                  handleDecline={handleAdminApproval}
                />

                {/* Check-In Confirmation Modal */}
                <Dialog
                  open={showCheckInConfirm}
                  onClose={() => setShowCheckInConfirm(false)}
                >
                  <DialogTitle>Confirm Check-In</DialogTitle>
                  <DialogContent>
                    <Typography>
                      Are you sure you want to check in to this ticket? This
                      will record your current location and time.
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setShowCheckInConfirm(false)}
                      color="inherit"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleCheckIn}
                      color="primary"
                      variant="contained"
                      disabled={
                        isGettingLocation || existingTicketData.isLoading
                      }
                    >
                      Confirm Check-In
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Check-Out Confirmation Modal */}
                <Dialog
                  open={showCheckOutConfirm}
                  onClose={() => setShowCheckOutConfirm(false)}
                >
                  <DialogTitle>Confirm Check-Out</DialogTitle>
                  <DialogContent>
                    <Typography>
                      Are you sure you want to check out from this ticket? This
                      will record your current location and time, and close this
                      check-in session.
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setShowCheckOutConfirm(false)}
                      color="inherit"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleCheckOut}
                      color="error"
                      variant="contained"
                      disabled={
                        isGettingLocation || existingTicketData.isLoading
                      }
                    >
                      Confirm Check-Out
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </DialogContent>
            <Divider />

            <DialogActions
              sx={{
                backgroundColor: "#fff", // Match NewTicketView
                borderTop: "1px solid #E2E8F0", // Match NewTicketView
                display: "flex",
                justifyContent: "flex-end",
                padding: isMobile ? "16px 16px 32px 16px" : "20px 32px",
              }}
            >
              <Box
                sx={{
                  marginRight: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {!existingTicketData.approvalRequireFlag &&
                  sessionUser.userType === "Admin" && (
                    <SaveButton
                      onClick={handleTicketUpdateSubmission}
                      disabled={
                        existingTicketData.approvalRequireFlag ||
                        existingTicketData.isLoading
                      }
                    />
                  )}
                {/* APPROVAL BUTTON */}
                {existingTicketData.approvalRequireFlag &&
                  ((existingTicketData.status === "reqCustomerAdminApproval" &&
                    (sessionUser.role === "customerAdmin" ||
                      sessionUser.userType === "Admin")) ||
                    (existingTicketData.status === "reqSuperAdminApproval" &&
                      (sessionUser.role === "coreAdmin" ||
                        sessionUser.role === "superAdmin" ||
                        sessionUser.role === "technicalAdmin"))) && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {existingTicketData.approvalRequireFlag &&
                        ["coreAdmin", "superAdmin"].includes(
                          sessionUser.role
                        ) && (
                          <Button
                            variant="contained"
                            color="secondary"
                            disabled={existingTicketData.isLoading}
                            onClick={() => {
                              dispatch({
                                type: "ticketManagement/updateFieldValues",
                                payload: {
                                  state: "existingTicket",
                                  field: "approvalRequireFlag",
                                  value: false,
                                },
                              });
                            }}
                            sx={{ marginRight: "10px" }}
                          >
                            Revert Approval Request
                          </Button>
                        )}
                      {existingTicketData.approvalRequireFlag &&
                        ((["coreAdmin", "superAdmin"].includes(
                          sessionUser.role
                        ) &&
                          existingTicketData.status ===
                          "reqSuperAdminApproval") ||
                          (["customerAdmin"].includes(sessionUser.role) &&
                            existingTicketData.status ===
                            "reqCustomerAdminApproval")) && (
                          <>
                            <Button
                              variant="contained"
                              color="error"
                              disabled={existingTicketData.isLoading}
                              onClick={() => {
                                handleAdminApproval("declined-without-reason");
                              }}
                              sx={{ marginRight: "10px" }}
                            >
                              Decline
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              disabled={existingTicketData.isLoading}
                              onClick={() => {
                                handleAdminApproval("approved");
                              }}
                            >
                              Approve
                            </Button>
                          </>
                        )}
                    </Box>
                  )}
              </Box>
            </DialogActions>
          </Paper>
        </div>
      </Dialog>

      {/* Inventory Selection Modal */}
      <Dialog
        open={showInventoryModal}
        onClose={() => setShowInventoryModal(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Select Inventory Items</Typography>
            <IconButton onClick={() => setShowInventoryModal(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {/* Filters */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Item Name"
                  value={inventoryFilters.itemName}
                  onChange={(e) =>
                    setInventoryFilters((prev) => ({
                      ...prev,
                      itemName: e.target.value,
                    }))
                  }
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  label="Asset Type"
                  value={inventoryFilters.assetType}
                  onChange={(e) =>
                    setInventoryFilters((prev) => ({
                      ...prev,
                      assetType: e.target.value,
                      brand: "",
                      model: "",
                    }))
                  }
                  options={inventoryAssetTypes.map((at) => ({
                    key: at._id,
                    name: at.name,
                  }))}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  label="Brand"
                  value={inventoryFilters.brand}
                  onChange={(e) =>
                    setInventoryFilters((prev) => ({
                      ...prev,
                      brand: e.target.value,
                      model: "",
                    }))
                  }
                  options={inventoryBrands.map((b) => ({
                    key: b._id,
                    name: b.name,
                  }))}
                  disabled={!inventoryFilters.assetType}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput
                  label="Model"
                  value={inventoryFilters.model}
                  onChange={(e) =>
                    setInventoryFilters((prev) => ({
                      ...prev,
                      model: e.target.value,
                    }))
                  }
                  options={inventoryModels.map((m) => ({
                    key: m._id,
                    name: m.name,
                  }))}
                  disabled={!inventoryFilters.brand}
                  size="small"
                />
              </Grid>
            </Grid>

            {/* Inventory Items List */}
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Available Items (Click to select)
              </Typography>
              <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
                {inventoryLoading &&
                  (!Array.isArray(inventoryItems) ||
                    inventoryItems.length === 0) ? (
                  <Typography>Loading...</Typography>
                ) : !Array.isArray(inventoryItems) ||
                  inventoryItems.length === 0 ? (
                  <Typography color="text.secondary">
                    No items found. Use filters to search.
                  </Typography>
                ) : (
                  <>
                    {Array.isArray(inventoryItems) &&
                      inventoryItems.map((item) => (
                        <Card
                          key={item._id}
                          sx={{
                            mb: 1,
                            p: 1.5,
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                          onClick={() => handleItemClick(item)}
                        >
                          <Typography variant="body2">
                            <strong>{item.itemName}</strong>
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {item.assetType?.name &&
                              `Type: ${item.assetType.name} `}
                            {item.brand?.name && `Brand: ${item.brand.name} `}
                            {item.model?.name && `Model: ${item.model.name} `}|
                            Stock: {item.stock}
                          </Typography>
                        </Card>
                      ))}
                    {(inventoryHasMore || inventoryCursor) && (
                      <Button
                        fullWidth
                        onClick={() => fetchInventoryItems(false)}
                        disabled={inventoryLoading}
                        sx={{ mt: 1 }}
                      >
                        {inventoryLoading ? "Loading..." : "Load More"}
                      </Button>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowInventoryModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Quantity Selection Dialog */}
      <Dialog
        open={quantityDialogOpen}
        onClose={() => {
          setQuantityDialogOpen(false);
          setItemForQuantity(null);
          setItemQuantity(1);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Select Quantity</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <strong>{itemForQuantity?.itemName}</strong>
              {itemForQuantity && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Available Stock: {itemForQuantity.stock}
                </Typography>
              )}
            </Typography>
            <TextField
              fullWidth
              label="Quantity"
              type="number"
              value={itemQuantity}
              onChange={(e) => {
                setItemQuantity(e.target.value);
              }}
              inputProps={{ min: 1 }}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setQuantityDialogOpen(false);
              setItemForQuantity(null);
              setItemQuantity(1);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmAddInventoryItem}
            variant="contained"
            disabled={
              !itemForQuantity ||
              itemQuantity < 1 ||
              itemQuantity > (itemForQuantity?.stock || 0)
            }
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExistingTicketView;
